<template>
    <el-row v-loading="loading" :class="[fundList.length < 7 ? 'row-class1': (fundList.length < 25 ? 'row-class2':'row-class3')]">
        <div :class="[fundList.length < 7 ? 'area-body1': (fundList.length < 25 ? 'area-body2':'area-body3')]">
            <div class="area-top">
                <div class="area-steps">
                   <div class="area-step">
                       <div class="step-top1"></div>
                       <div class="ea-nav">
                            <div
                            v-for="(item, ii) in withoutSmallStepData"
                            :key="ii"
                            :class="['ea-nav-item', stepIndex>=ii?'ea-nav-done':'', stepIndex==ii?'ea-nav-active':'']"
                            >
                            <div class="ea-nav-name">
                                {{ item.title }}
                            </div>
                            <div class="ea-nav-progress">
                                <div />
                            </div>
                            </div>
                        </div>
                   </div>
                </div>
            </div>
            
        <transition name="fade">
            <div class="area-main" v-if="show1Div" :class="{slideIn: showIn, slideOut: showOut}">
                <div class="area-content">
                    <div class="content-title">
                        <span class="title-text">
                            创建组合
                        </span>
                    </div>
                    <div class="content-main">
                        <div class="zuhe-title">
                            <span class="zuhe-name">组合名称 *</span>
                        </div>
                        <div class="zuhe-input">
                            <el-input
                                placeholder="请输入组合名称"
                                v-model="reportName"
                                clearable>
                            </el-input>
                        </div>
                        <div class="touma-title">
                            <div class="touma-name">投资顾问</div>
                            <div class="touma-space"></div>
                            <div class="touma-name">组合代码</div>
                        </div>
                        <div class="touma-input">
                            <div class="touma-value">
                                <el-input
                                placeholder="请输入投资顾问"
                                v-model="counselor"
                                clearable>
                                </el-input>
                            </div>
                            <div class="touma-space"></div>
                            <div class="touma-value">
                                <el-input
                                placeholder="请输入组合代码"
                                v-model="reportCode"
                                clearable>
                                </el-input>
                            </div>
                        </div>
                        <div class="timerebalance-title">
                            <div class="touma-name">组合时间</div>
                            <div class="touma-space"></div>
                            <div class="touma-name">再平衡周期*</div>
                        </div>
                        <div class="timerebalance-input">
                            <div class="touma-value2">
                                <el-date-picker
                                size="large"
                                    v-model="portfolioDate"
                                    type="date"
                                    placeholder="选择日期"
                                    class="portfolioDate_input left_float"
                            >
                            </el-date-picker>
                            </div>
                            <!-- <div class="touma-space"></div> -->
                            <div class="touma-value3">
                                <el-select
                                    v-model="rebalanceFrequency"
                                    class="rebalanceFrequency_input"
                                    width="100px"
                                    popper-class="select-class"
                                >
                                <el-option
                                    selected="selected"
                                    label="买入并持有"
                                    value="buyandhold"
                                ></el-option>
                                <el-option label="月度" value="monthly"></el-option>
                                <el-option label="季度" value="quarterly"></el-option>
                                <el-option label="半年度" value="semi-annually"></el-option>
                                <el-option label="年度" value="annually"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="risklevel-title">
                            <div class="risklevel-name">
                                <el-checkbox
                                    v-model="isChangeRisk"                    
                                    class="el-checkbox_overwrite1"
                                ></el-checkbox>
                                风险等级稳定性调整
                            </div>
                            <div class="risklevel-space"></div>
                            <div class="risklevel-name">
                                <el-checkbox
                                    size="mini"
                                    v-model="isSelectedEFAF"                    
                                    class="el-checkbox_overwrite2"
                                ></el-checkbox>
                                权益基金谨慎性调整
                            </div>
                        </div>
                        <div class="lasterrisk-title">
                            <span class="lasterrisk-name">上期风险等级</span>
                        </div>
                        <div class="risk-input">
                            <el-select
                                    v-model="lastRisk"
                                    :disabled="!isChangeRisk"
                                    class="lastRisk_input"
                                    width="100px"
                                    popper-class="select-class"
                                >
                                <el-option
                                    selected="selected"
                                    label="低风险 R1"
                                    value="1"
                                ></el-option>
                                <el-option label="中低风险 R2" value="2"></el-option>
                                <el-option label="中风险 R3" value="3"></el-option>
                                <el-option label="中高风险 R4" value="4"></el-option>
                                <el-option label="高风险 R5" value="5"></el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
            </div>
        </transition> 

        <transition name="fade">
            <div class="area-main" v-if="show2Div">
                <div class="area-content">
                    <div class="content-title">
                        <span class="title-text">
                            持仓信息
                        </span>
                    </div>
                    <div class="content-main">
                        <div class="funtion-area">
                            <div class="inout-div">
                                <el-upload
                                    class="left_float"
                                    action="https://morningstar.cn/"
                                    :on-change="importPortfolioHoldings"
                                    :auto-upload="false"
                                    :show-file-list="false"
                                >
                                <el-button size="medium" round icon="el-icon-upload2">导入基金列表</el-button>
                                </el-upload>
                            </div>
                            <div class="inout-div">
                                <!-- <el-button 
                                    size="medium" 
                                    round icon="el-icon-download" 
                                    @click="exportPortfolioHoldings"
                                    disabled="totalRisk === ''">导出基金列表
                                </el-button> -->
                            </div>
                            <div class="space-div">
                            </div>
                            <div class="inout2-div">
                                <el-button type="text" @click="downloadTemplateFile"
                                    >下载Excel模板</el-button>
                            </div>
                        </div>
                        <div class="fundList-title">

            <el-col :span="24" class="div-right-border">
                <el-table
                    :data="fundList"
                    style="width: 100%;"
                    :key="tableKey"
                    class="portfolioRiskTable"
                    :row-style="{ height: '90px' }"
                >
                    <el-table-column
                        fixed
                        type="index"
                        label="序列"
                        width="80"
                    ></el-table-column>
                    <el-table-column
                        prop="symbol"
                        label="产品名称"
                        min-width="130"
                    >
                        <template slot-scope="scope">

                            <el-popover
                                placement="bottom"
                                width="320px"
                                :ref="'items_' + scope.$index"
                            >
                                <el-row
                                    style="width: 320px; height: 300px"
                                    v-loading="loading2"
                                >
                                    <el-scrollbar
                                        ref="search_scrollbar"
                                        style="height: 100%"
                                        class="scroll-no-horiz-bar"
                                    >
                                        <el-row
                                            style="
                                                text-align: left;
                                                margin: 0;
                                                font-size: 12px;
                                                cursor: pointer;
                                            "
                                            v-for="(node, index) in state"
                                            class="fundInformation"
                                            :key="index"
                                        >
                                            <el-col
                                                :span="24"
                                                v-html="node"
                                                @click.native="
                                                    getFundInformation(node)
                                                "
                                                :ref="'cssClass' + index"
                                                @mouseenter.native="
                                                    changeClass($event, index)
                                                "
                                                :class="{
                                                    searchHover: 1 === index,
                                                }"
                                            ></el-col>
                                        </el-row>
                                    </el-scrollbar>
                                </el-row>
                                <el-input
                                    v-model="scope.row.symbolInfo"
                                    slot="reference"
                                    placeholder=""
                                    type="text"
                                    style="width: 82% !important"
                                    suffix-icon="el-icon-asset-search"
                                    @input="
                                        searchFundCache(
                                            scope.row.symbolInfo,
                                            scope.$index
                                        )
                                    "
                                    @focus="handleFocus(scope.$index, $event)"
                                ></el-input>
                            </el-popover>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="weight"
                        :label="'权重分配%'"
                        min-width="60"
                        align="left"
                    >
                        <template slot-scope="scope">
                            <el-input
                                v-model="scope.row.weight"
                                type="text"
                                style="width: 80% !important"
                                placeholder=""
                                suffix-icon="el-icon-asset-percent"
                                @blur="handleCalRatio"
                            ></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="weight1" min-width="20" align="left">
                        <template slot-scope="scope">
                            <i
                                style="font-size: 26px"
                                :class="scope.$index == fundList.length -1 ? 'el-icon-plus'  : 'el-icon-close'"
                                @click="handleRemoveRecord(scope.$index)"
                            ></i>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
                        </div>
                        <div class="fenpei-area">
                            <div class="fenpei-div1">
                                <el-button type="info" @click="handleAvg" round>平均分配权重</el-button>
                            </div>
                            <div class="fenpei-space1"></div>
                            <div class="fenpei-div2">
                                <span class="fenpei-text">*  权重分配必须为100%</span>
                            </div>
                            <div class="fenpei-space2"> </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

        <transition name="fade">
            <div class="area-main" v-if="show3Div" :class="{slideIn: showIn, slideOut: showOut}">
                <div class="area-content">
                    <div class="content-title">
                        <span class="title-text">
                            诊断结果
                        </span>
                    </div>
                    <div class="content-main risk-result-main">
                        <div class="result-div">
                            <div class="result-img"></div>
                            <div class="result-text">
                                <span v-if="totalRiskText == '1'">R1 低风险</span>
                                <span v-if="totalRiskText == '2'">R2 中低风险</span>
                                <span v-if="totalRiskText == '3'">R3 中风险</span>
                                <span v-if="totalRiskText == '4'">R4 中高风险</span>
                                <span v-if="totalRiskText == '5'">R5 高风险</span>
                            </div>
                            <div class="result-space"></div>
                            <div class="result-steps1" v-if="totalRiskText == '1'"></div>
                            <div class="result-steps2" v-if="totalRiskText == '2'"></div>
                            <div class="result-steps3" v-if="totalRiskText == '3'"></div>
                            <div class="result-steps4" v-if="totalRiskText == '4'"></div>
                            <div class="result-steps5" v-if="totalRiskText == '5'"></div>
                        </div>
                        <div class="calcuate-div">
                            <div class="calcuate-title">
                                <div class="sonrisk-div">子项风险</div>
                                <div class="sonrisk-space"></div>
                                <div class="sonrisk-sum">
                                    总体风险得分: <span class="sum-text">{{totalRiskText.length === 1 ? totalRiskText + ".0" : totalRiskText}}</span>
                                </div>
                            </div>
                            <div class="calcuate-result">
                                <div class="result-area">
                                    <div class="result-title">
                                        <span>组合持仓风险：</span>
                                    </div>
                                    <div class="result-compass">
                                        <RiskScale :score="positionRiskScore" />
                                    </div>
                                    <div class="calcuate-space1"><span>{{positionRiskScore.length === 1 ? positionRiskScore + ".0" : positionRiskScore}}</span></div>
                                    <div class="result-title">
                                        <span>下行波动风险：</span>
                                    </div>
                                    <div class="result-compass">
                                        <RiskScale :score="downsideDeviationLevel" />
                                    </div>
                                    <div class="calcuate-space2"><sapn>{{downsideDeviationLevel.length === 1 ? downsideDeviationLevel + ".0" : downsideDeviationLevel}}</sapn></div>
                                </div>
                            </div>

                            <div class="calcuate-result">
                                <div class="result-area">
                                    <div class="result-title">
                                        <span>评级调整风险：</span>
                                    </div>
                                    <div class="result-compass">
                                        <RiskScale :score="morningstarRiskLevel" />
                                    </div>
                                    <div class="calcuate-space1"><span>{{morningstarRiskLevel.length === 1 ? morningstarRiskLevel + ".0" : morningstarRiskLevel}}</span></div>
                                    <div class="result-title">
                                        <span>附加规模风险：</span>
                                    </div>
                                    <div class="result-compass">
                                        <RiskScale :score="additionalScaleScore" />
                                    </div>
                                    <div class="calcuate-space2"><span>{{additionalScaleScore.length === 1 ? additionalScaleScore + ".0" : additionalScaleScore}}</span></div>
                                </div>
                            </div>

                            <div class="calcuate-result">
                                <div class="result-area">
                                    <div class="result-title">
                                        <span>业绩波动风险：</span>
                                    </div>
                                    <div class="result-compass">
                                        <RiskScale :score="standardDeviationLevel" />
                                    </div>
                                    <div class="calcuate-space1"><span>{{standardDeviationLevel.length === 1 ? standardDeviationLevel + ".0" : standardDeviationLevel}}</span></div>
                                    <div class="result-title">
                                        <!-- <span>下行波动风险：</span> -->
                                    </div>
                                    <div class="result-compass">
                                        <!-- <div class="process-area">
                                            <div class="process-step1">
                                                <div class="process-circle-big">
                                                    <div class="process-circle-small"></div>
                                                </div>
                                            </div>
                                        </div> -->
                                    </div>
                                    <div class="calcuate-space2"></div>
                                </div>
                            </div>

                        </div>
                        <div class="funtion-div">
                            <div class="funtion-export">
                                <el-button size="small" icon="el-icon-download" @click="exportPortfolioHoldings" :disabled="totalRisk === ''" round>导出风险数据</el-button>
                            </div>
                            <div class="funtion-import">
                                <el-button size="small" icon="el-icon-document"  @click="handleDown" :disabled="!reportFlag" v-if="reportFlag === true || clickFlag === false" v-show="portfolioSuitabilityMemberSenior || portfolioSuitabilityMemberBase" round>下载PDF报告</el-button>
                                <el-button :loading="true" v-else>报告生成中</el-button>
                            </div>
                            <div class="funtion-space"> </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

        </div>
        <div
            ref="floatPanel"
            style="position: absolute; bottom: -66px; z-index: 999; height: 110px;width:100%; background-color: #ffffff;"
        >
            <el-button size="small" v-show="showForwardButton" icon="el-icon-arrow-left" round @click="forwardStep" style="border: 0;margin-right: 1076px;left:10px;position:absolute;">返回</el-button>
            <el-button type="primary" style="right:20px;position:absolute;" size="small" v-show="showNextButton" round @click="nextStep" :style="{'margin-left': marginLeft }">{{nextStepText}}<i class="el-icon-arrow-right el-icon--right"></i></el-button>

        <!-- <el-row class="padding_15px_top padding_15px_bottom">
            <el-col
                class="portfolio_front left_text_align"
                :span="2"
                style="line-height: 40px"
                >组合日期：</el-col
            >
            <el-col class="left_float" :span="4">
                <el-date-picker
                    v-model="portfolioDate"
                    type="date"
                    placeholder="选择日期"
                    class="portfolioDate_input left_float"
                >
                </el-date-picker>
            </el-col>
            <el-col :span="7" class="portfolio_front">
                再平衡周期：
                <el-select
                    v-model="rebalanceFrequency"
                    class="rebalanceFrequency_input"
                    width="100px"
                >
                    <el-option
                        selected="selected"
                        label="买入并持有"
                        value="buyandhold"
                    ></el-option>
                    <el-option label="月度" value="monthly"></el-option>
                    <el-option label="季度" value="quarterly"></el-option>
                    <el-option label="半年度" value="semi-annually"></el-option>
                    <el-option label="年度" value="annually"></el-option>
                </el-select>
            </el-col>
            <el-col
                :span="4"
                class="portfolio_front left_text_align"
                style="line-height: 40px"
                >风险等级稳定性调整：
                <el-checkbox
                    v-model="isChangeRisk"                    
                    class="el-checkbox_overwrite"
                ></el-checkbox>
            </el-col>
            <el-col :span="7" class="portfolio_front right_text_align"
                >上期风险等级：
                <el-select
                    v-model="lastRisk"
                    :disabled="!isChangeRisk"
                    class="lastRisk_input"
                >
                    <el-option
                        selected="selected"
                        label="低风险 R1"
                        value="1"
                    ></el-option>
                    <el-option label="中低风险 R2" value="2"></el-option>
                    <el-option label="中风险 R3" value="3"></el-option>
                    <el-option label="中高风险 R4" value="4"></el-option>
                    <el-option label="高风险 R5" value="5"></el-option>
                </el-select>
            </el-col>
        </el-row>
        <el-row
            class="padding_15px_top padding_15px_bottom"
            type="flex"
            justify="start"
        >
            <el-col
                class="portfolio_front left_text_align"
                :span="2"
                style="line-height: 40px"
                >选择文件：</el-col
            >
            <el-col class="" :span="4">
                <el-upload
                    class="left_float"
                    action="https://morningstar.cn/"
                    :on-change="importPortfolioHoldings"
                    :auto-upload="false"
                    :show-file-list="false"
                >
                    <el-button style="width:182px" type="primary">导入基金列表</el-button>
                </el-upload>
            </el-col>
            <el-col class="" :span="3">
                <div class="portfolio_risk_label_front">
                    <span class="demonstration">请</span>
                    <el-button type="text" @click="downloadTemplateFile"
                        >下载</el-button
                    >
                    <span class="demonstration">模板文件</span>
                </div>
            </el-col>
            <el-col
                :offset="4"
                :span="4"
                class="portfolio_front left_text_align"
                style="line-height: 40px"
                >权益基金谨慎性调整：
                <el-checkbox
                    v-model="isSelectedEFAF"                    
                    class="el-checkbox_overwrite"
                ></el-checkbox>
            </el-col>
            <el-col class="" offset="4" :span="3">
                <el-button
                    class="right_float"
                    style="width:182px"
                    icon="icon_export"
                    @click="exportPortfolioHoldings"
                    :disabled="totalRisk === ''"
                    >导出基金列表</el-button
                >
            </el-col>
        </el-row>
        <br />
        <el-row class="mainContent">
            <el-col :span="16" class="div-right-border">
                <el-table
                    :data="fundList"
                    style="width: 100%"
                    :key="tableKey"
                    class="portfolioRiskTable"
                    :row-style="{ height: '80px' }"
                >
                    <el-table-column
                        fixed
                        type="index"
                        label="序号"
                        width="80"
                    ></el-table-column>
                    <el-table-column
                        prop="symbol"
                        label="产品名称"
                        min-width="130"
                    >
                        <template slot-scope="scope">

                            <el-popover
                                placement="bottom"
                                width="320px"
                                :ref="'items_' + scope.$index"
                            >
                                <el-row
                                    style="width: 320px; height: 300px"
                                    v-loading="loading2"
                                >
                                    <el-scrollbar
                                        ref="search_scrollbar"
                                        style="height: 100%"
                                        class="scroll-no-horiz-bar"
                                    >
                                        <el-row
                                            style="
                                                text-align: left;
                                                margin: 0;
                                                font-size: 12px;
                                                cursor: pointer;
                                            "
                                            v-for="(node, index) in state"
                                            class="fundInformation"
                                            :key="index"
                                        >
                                            <el-col
                                                :span="24"
                                                v-html="node"
                                                @click.native="
                                                    getFundInformation(node)
                                                "
                                                :ref="'cssClass' + index"
                                                @mouseenter.native="
                                                    changeClass($event, index)
                                                "
                                                :class="{
                                                    searchHover: 1 === index,
                                                }"
                                            ></el-col>
                                        </el-row>
                                    </el-scrollbar>
                                </el-row>
                                <el-input
                                    v-model="scope.row.symbolInfo"
                                    slot="reference"
                                    placeholder=""
                                    type="text"
                                    style="width: 82% !important"
                                    suffix-icon="el-icon-asset-search"
                                    @input="
                                        searchFundCache(
                                            scope.row.symbolInfo,
                                            scope.$index
                                        )
                                    "
                                    @focus="handleFocus(scope.$index, $event)"
                                ></el-input>
                            </el-popover>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="weight"
                        :label="'权重分配（百分比）'"
                        min-width="60"
                        align="left"
                    >
                        <template slot-scope="scope">
                            <el-input
                                v-model="scope.row.weight"
                                type="text"
                                style="width: 80% !important"
                                placeholder=""
                                suffix-icon="el-icon-asset-percent"
                                @blur="handleCalRatio"
                            ></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="weight1" min-width="20" align="left">
                        <template slot-scope="scope">
                            <i
                                style="font-size: 26px"
                                class="el-icon-trash"
                                @click="handleRemoveRecord(scope.$index)"
                            ></i>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
            <el-col
                :span="8"
                style="height: 460px; left: -1px"
                class="div-left-bottom-top-border"
            >
                <el-row class="portfolio_front">
                    <el-col
                        class="portfolio_front left_text_align"
                        :span="21"
                        :offset="3"
                        style="line-height: 60px"
                    >
                        <span class="portfolio_risk_label_front font_bold"
                            >风险等级结果：</span
                        >
                        <span class="portfolio_risk_font">{{ totalRisk }}</span>
                    </el-col>
                </el-row>
                <el-row class="portfolio_front" style="height: 1px"> </el-row>
                <el-row
                    :class="portfolio_risk_label_front"
                    style="height: 100px"
                    :align="middle"
                >
                    <template v-if="totalRisk">
                        <el-col
                            :span="21"
                            :offset="3"
                            class="right_text_align"
                            :class="riskCss"
                        ></el-col>
                    </template>
                    <template v-else>
                        <el-col :span="13" :offset="11" class="left_text_align">
                            <span
                                class="portfolio_risk_font_big"
                                style="line-height: 100px"
                                >暂未评定</span
                            >
                        </el-col>
                    </template>
                </el-row>
                <el-row class="portfolio_front" style="height: 25px"> </el-row>
                <el-row class="portfolio_risk_label_front">
                    <el-col
                        :span="8"
                        :offset="3"
                        class="left_text_align"
                        style="line-height: 40px"
                    >
                        <span>组合持仓风险：</span>
                    </el-col>
                    <el-col :span="13" style="margin-top: 10px">
                        <el-progress
                            class="progress-bar"
                            :text-inside="true"
                            :stroke-width="14"
                            :format="progressFormat"
                            :percentage="positionRiskScore_percentage"
                            status="warning"
                        ></el-progress>
                    </el-col>
                </el-row>
                <el-row class="portfolio_risk_label_front">
                    <el-col
                        :span="8"
                        :offset="3"
                        class="left_text_align"
                        style="line-height: 40px"
                    >
                        <span>评级调整风险：</span>
                    </el-col>
                    <el-col :span="13" style="margin-top: 10px">
                        <el-progress
                            class="progress-bar"
                            :text-inside="true"
                            :stroke-width="14"
                            :format="progressFormat"
                            :percentage="morningstarRiskLevel_percentage"
                            status="warning"
                        ></el-progress>
                    </el-col>
                </el-row>
                <el-row class="portfolio_risk_label_front">
                    <el-col
                        :span="8"
                        :offset="3"
                        class="left_text_align"
                        style="line-height: 40px"
                    >
                        <span>业绩波动风险：</span>
                    </el-col>
                    <el-col :span="13" style="margin-top: 10px">
                        <el-progress
                            class="progress-bar"
                            :text-inside="true"
                            :stroke-width="14"
                            :format="progressFormat"
                            :percentage="standardDeviationLevel_percentage"
                            status="warning"
                        ></el-progress>
                    </el-col>
                </el-row>
                <el-row class="portfolio_risk_label_front">
                    <el-col
                        :span="8"
                        :offset="3"
                        class="left_text_align"
                        style="line-height: 40px"
                    >
                        <span>下行波动风险：</span>
                    </el-col>
                    <el-col :span="13" style="margin-top: 10px">
                        <el-progress
                            class="progress-bar"
                            :text-inside="true"
                            :stroke-width="14"
                            :percentage="downsideDeviationLevel_percentage"
                            :format="progressFormat"
                            status="warning"
                        ></el-progress>
                    </el-col>
                </el-row>
                <el-row class="portfolio_risk_label_front">
                    <el-col
                        :span="8"
                        :offset="3"
                        class="left_text_align"
                        style="line-height: 40px"
                    >
                        <span>总体风险得分：</span>
                    </el-col>
                    <el-col :span="13" style="margin-top: 10px">
                        <el-progress
                            class="progress-bar"
                            :text-inside="true"
                            :stroke-width="14"
                            :percentage="totalRisk_percentage"
                            :format="progressFormat"
                            status="warning"
                        ></el-progress>
                    </el-col>
                </el-row>
                <el-row class="portfolio_risk_label_front">
                    <el-col
                        :span="8"
                        :offset="3"
                        class="left_text_align"
                        style="line-height: 40px"
                    >
                        <span>附加规模风险：</span>
                    </el-col>
                    <el-col :span="13" style="margin-top: 10px">
                        <el-progress
                            class="progress-bar"
                            :text-inside="true"
                            :stroke-width="14"
                            :percentage="additionalScaleScore_percentage"
                            :format="progressFormat"
                            status="warning"
                        ></el-progress>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
        <el-row style="height:50px">

        </el-row> -->
        <br />
        <!-- <div
            ref="floatPanel"
            style="position: fixed; bottom: -65px; z-index: 999; height: 92px; width:89%"
        > -->

            <!-- <el-row
                class="floating-bottom-panel portfolio_risk_label_front"
                :align="middle"
            > -->
                <!-- <el-col :span="2" class="left_text_align div-subElement-center">
                    <el-button icon="el-icon-asset-add" @click="handleAddRecord"
                        >添加</el-button
                    >
                </el-col>
                <el-col
                    :span="2"
                    style="margin-left: 20px"
                    class="left_text_align div-subElement-center"
                >
                    <el-button
                        icon="el-icon-refresh-left"
                        @click="handleResetRecord"
                        >重置</el-button
                    >
                </el-col>
                <el-col
                    :span="3"
                    :offset="6"
                    class="portfolio_risk_label_front left_text_align div-subElement-center"
                    style="width: 120px"
                >
                    权重分配总数：{{ portfolioRatio }}%
                </el-col>
                <el-col
                    :span="2"
                    :offset="3"
                    class="right_text_align div-subElement-center right_float"
                >
                    <el-button type="primary" @click="handleAvg"
                        >平均分配权重</el-button
                    >
                </el-col>
                <el-col
                    :span="2"
                    :offset="1"
                    class="right_text_align div-subElement-center right_float"
                >
                    <el-button type="primary" @click="handleCalculation"
                        >&nbsp;&nbsp;计算风险等级&nbsp;&nbsp;</el-button
                    >
                </el-col>
                <el-col
                    :span="2"
                    :offset="2"
                    class="right_text_align div-subElement-center right_float"
                    style="margin-top: -41px;margin-left:90.5%;"
                >
                    <el-button type="primary" @click="handleDown" :disabled="!reportFlag" v-if="reportFlag === true || clickFlag === false" v-show="portfolioSuitabilityMemberSenior || portfolioSuitabilityMemberBase"
                        >下载报告</el-button
                    >
                    <el-button type="primary" :loading="true" v-else>报告生成中</el-button>
                </el-col> -->

            <!-- </el-row> -->

            <!-- <el-steps :active="1" align-center>
        <el-step :title="task.taskName" v-for="task in taskSteps" :key="task.taskId">
           <i class="iconfont icon-buzhouyi" slot="icon"></i>
        </el-step>
      </el-steps> -->



        <div :id="[fundTextList.length < 23 ? 'demo2': (fundTextList.length < 50 ? 'demo3':'demo4')]">
            <div class="head-area">
                <div class="head-content">
                    <span class="head-date">报告生成日期：{{currentDate}}</span>
                    <span class="head-title">{{reportName}}基金组合报告</span>
                </div>
                <div class="logo-img" />
            </div>

            <div class="des-div">
                <div class="des-msg">
                    <div class="desc">
                        <span class="desc-title">组合名称</span>
                        <span class="desc-content">{{reportName}}</span>
                    </div>
                    <div class="desc">
                        <span class="desc-title">组合代码</span>
                        <span class="desc-content">{{reportCode}}</span>
                    </div>
                    <div class="desc">
                        <span class="desc-title">组合持仓日期</span>
                        <span class="desc-content2">{{selectDate}}</span>
                    </div>
                    <div class="desc">
                        <span class="desc-title">投资顾问</span>
                        <span class="desc-content">{{counselor}}</span>
                    </div>
                </div>
            </div>

            <div class="comeupRisk-desc">
                <div class="comeupRisk-div1">
                    <span class="comeupRisk-title">组合综合风险综述</span>
                </div>
                <div class="comeupRisk-div2">
                    <div class="comeupRisk-area">
                        <span class="comeupRisk-text">该基金组合的综合风险评价为<span style="font-weight:600;">{{input1}}</span>。其中组合持仓风险为{{input2}}，评级调整风险为{{input3}}，业绩波动风险为{{input4}}，下行波动风险为{{input5}}，附加规模风险为{{input6}}。该基金组合适合风险承受能力为{{input7}}及以上的基金投资人购买。</span>
                    </div>
                </div>
            </div>

            <div class="comeupRisk-desc">
                <div class="comeupRisk-div1">
                    <span class="evalRisk-title">风险评价</span>
                </div>
                <div class="comeupRisk-div2">
                <div class="evalRisk-div2">
                    <div class="levelArea-div">
                            <div class="area11">
                                低(R1)
                                <div class="area-background" v-show="allRiskType === 1">
                                    低(R1) 
                                </div>
                            </div>
                            <div class="area12">
                                中低(R2)
                                <div class="area-background" v-show="allRiskType === 2">
                                    中低(R2)
                                </div>
                            </div>
                            <div class="area13">
                                中(R3)
                                <div class="area-background" v-show="allRiskType === 3">
                                    中(R3)
                                </div>
                            </div>
                            <div class="area14">
                                中高(R4)
                                <div class="area-background" v-show="allRiskType === 4">
                                    中高(R4)
                                </div>
                            </div>
                            <div class="area15">
                                高(R5)
                                <div class="area-background" v-show="allRiskType === 5">
                                    高(R5)
                                </div>
                            </div>
                        </div>
                    <div class="levelArea-div2">
                            <div class="area2-div">
                                <div class="area2" style="width: 0;height: 0;border-left: 10px solid transparent;border-right: 10px solid transparent;border-bottom: 20px solid black;" v-show="allRiskType === 1"></div>
                            </div>
                            <div class="area2-div">
                                <div class="area3" style="width: 0;height: 0;border-left: 10px solid transparent;border-right: 10px solid transparent;border-bottom: 20px solid black;" v-show="allRiskType === 2"></div>
                            </div>
                            <div class="area2-div">
                                <div class="area4" style="width: 0;height: 0;border-left: 10px solid transparent;border-right: 10px solid transparent;border-bottom: 20px solid black;" v-show="allRiskType === 3"></div>
                            </div>
                            <div class="area2-div">
                                <div class="area5" style="width: 0;height: 0;border-left: 10px solid transparent;border-right: 10px solid transparent;border-bottom: 20px solid black;" v-show="allRiskType === 4"></div>
                            </div>
                            <div class="area2-div">
                                <div class="area6" style="width: 0;height: 0;border-left: 10px solid transparent;border-right: 10px solid transparent;border-bottom: 20px solid black;" v-show="allRiskType === 5"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="zixiang-desc">
                <div class="zixiang-div1">
                    <span class="comeupRisk-title">子项风险</span>
                </div>
                <div class="zixiang-div2">
                    <div class="zixiang-div3">
                            <div class="item-div">
                                <span class="item-text">组合持仓风险：</span>
                                <el-col :span="17" style="margin-top: 16px;margin-left: 47px;">
                                <el-progress
                                    class="progress-bar2"
                                    :text-inside="true"
                                    :stroke-width="13"
                                    :percentage="positionRiskScore_percentage"
                                    :format="progressFormat"
                                    status="warning"
                                ></el-progress>
                                </el-col>
                            </div>
                            <div class="item-div">
                                <span class="item-text">评级调整风险：</span>
                                <el-col :span="17" style="margin-top: 16px;margin-left: 47px;">
                                    <el-progress
                                        class="progress-bar2"
                                        :text-inside="true"
                                        :stroke-width="13"
                                        :format="progressFormat"
                                        :percentage="morningstarRiskLevel_percentage"
                                        status="warning"
                                    ></el-progress>
                                </el-col>
                            </div>
                            <div class="item-div">
                                <span class="item-text">业绩波动风险：</span>
                                <el-col :span="17" style="margin-top: 16px;margin-left: 47px;">
                                    <el-progress
                                        class="progress-bar2"
                                        :text-inside="true"
                                        :stroke-width="13"
                                        :format="progressFormat"
                                        :percentage="standardDeviationLevel_percentage"
                                        status="warning"
                                    ></el-progress>
                                </el-col>
                            </div>
                            <div class="item-div">
                                <span class="item-text">下行波动风险：</span>
                                <el-col :span="17" style="margin-top: 16px;margin-left: 47px;">
                                    <el-progress
                                        class="progress-bar2"
                                        :text-inside="true"
                                        :stroke-width="13"
                                        :format="progressFormat"
                                        :percentage="downsideDeviationLevel_percentage"
                                        status="warning"
                                    ></el-progress>
                                </el-col>
                            </div>
                            <div class="item-div">
                                <span class="item-text">总体风险得分：</span>
                                <el-col :span="17" style="margin-top: 16px;margin-left: 47px;">
                                    <el-progress
                                        class="progress-bar2"
                                        :text-inside="true"
                                        :stroke-width="13"
                                        :format="progressFormat"
                                        :percentage="totalRisk_percentage"
                                        status="warning"
                                    ></el-progress>
                                </el-col>
                            </div>
                            <div class="item-div">
                                <span class="item-text">附加规模风险：</span>
                                <el-col :span="17" style="margin-top: 16px;margin-left: 47px;">
                                    <el-progress
                                        class="progress-bar2"
                                        :text-inside="true"
                                        :stroke-width="13"
                                        :format="progressFormat"
                                        :percentage="additionalScaleScore_percentage"
                                        status="warning"
                                    ></el-progress>
                                </el-col>
                            </div>
                    </div>
                    <div class="zixiang-div4">
                        <div class="pingheng-div"><span style="font-weight: 600;">再平衡周期：</span><span>{{balanceDateText}}</span></div>
                        <div class="pingheng-div"><span style="font-weight: 600;">业绩不足三年的基金占比：</span><span>{{yjNotMoreText}}</span></div>
                        <div class="fengxian-div"><span style="font-weight: 600;">风险等级稳定性调整：</span><span>{{riskLevelText}}</span></div>
                        <div class="fengxian-div"><span style="font-weight: 600;">上期风险等级：</span><span>{{UpRiskLevelText}}</span></div>
                        <div class="fengxian-div"><span style="font-weight: 600;">权益基金谨慎性调整：</span><span>{{qyFundText}}</span></div>
                    </div>
                    <div class="zixiang-div5">
                        <span>注：基金组合的晨星风险、波动风险、下跌风险指标评价是基于全市场公募基金的评价结果。</span>
                    </div>
                </div>
            </div>

            <div class="zuhe-desc">
                <div class="zuhe-div1">
                    <span class="comeupRisk-title">组合持仓信息</span>
                </div>
                <div class="zuhe-div2">
                    <div class="msg-div">
                        <div class="msg-head">
                            <div class="head1">基金代码</div>
                            <div class="head2">基金名称</div>
                            <div class="head3">基金类型</div>
                            <div class="head4">晨星评级(三年)</div>
                            <div class="head5">风险等级</div>
                            <div class="head6">持仓比例(%)</div>
                        </div>
                        <div class="msg-content"  v-for="(item,index) in fundTextList.slice(0,4)" :key="index">
                            <div class="head1" style="font-weight: 545;font-size: 14px;">{{item.symbol}}</div>
                            <div class="head2" style="font-weight: 545;font-size: 14px;">{{item.symbolInfo.slice(7,100)}}</div>
                            <div class="head3" style="font-weight: 545;font-size: 14px;">{{item.type}}</div>
                            <div class="head4" style="font-weight: 545;font-size: 14px;">
                                <div class="msg-star" v-if="item.rank === '1'">
                                    <div class="star"></div>
                                </div>
                                <div class="msg-star" v-else-if="item.rank === '2'">
                                    <div class="star"></div>
                                    <div class="star"></div>
                                </div>
                                <div class="msg-star" v-else-if="item.rank === '3'">
                                    <div class="star"></div>
                                    <div class="star"></div>
                                    <div class="star"></div>
                                </div>
                                <div class="msg-star" v-else-if="item.rank === '4'">
                                    <div class="star"></div>
                                    <div class="star"></div>
                                    <div class="star"></div>
                                    <div class="star"></div>
                                </div>
                                <div class="msg-star" v-else-if="item.rank === '5'">
                                    <div class="star"></div>
                                    <div class="star"></div>
                                    <div class="star"></div>
                                    <div class="star"></div>
                                    <div class="star"></div>
                                </div>
                                <div v-else>
                                    {{item.rank}}
                                </div>
                            </div>
                            <div class="head5" style="font-weight: 545;font-size: 14px;">{{item.level}}</div>
                            <div class="head6" style="font-weight: 545;font-size: 14px;">{{parseFloat(item.weight).toFixed(2)}}</div>
                            <!-- <div class="head6" style="font-weight: 100;">{{item.num}}</div> -->
                            <!-- </div> -->
                        </div>
                    </div>
                    <div class="msDate-area" v-show="fundTextList.length < 5">
                        <div class="msDate-div">风险等级更新日期：{{riskDate}}</div>
                        <div class="msDate-div">晨星评级更新日期：{{ratingDate}}</div>
                    </div>
                </div>
            </div>

            <div class="comeupRisk-desc">
                <div class="bottomlogo-div">
                    <div class="ms-newlogo"></div>
                </div>
                <div class="bottomtext-div">
                    <div class="bottomText-area">
                        <span class="comeupRisk-text">晨星（Morningstar）不保证信息的准确性、完整性和及时性，同时也不保证不会发生任何变更。此资料、数据、观点仅供参考，并不构成投资建议。在任何情况下，我公司不就本报告中的任何内容对任何投资行为做出任何形式的担保。本报告内容的版权归晨星资讯,(深圳)有限公司所有，未获得书面授权许可，不得以任何形式复制或用于制作报告、文件等用途。</span>
                    </div>
                </div>
            </div>

            <div class="head-area">
                <div class="head-content">
                    <span class="head-date">报告生成日期：{{currentDate}}</span>
                    <span class="head-title">{{reportName}}基金组合报告</span>
                </div>
                <div class="logo-img" />
            </div>

            <div class="note-desc" v-show="fundTextList.length < 5">
                <div class="note-title">
                    <span class="comeupRisk-title">备注</span>
                </div>
                <div class="note-text">
                    <div class="noteText-area">
                        <div class="noteText-div1">根据中国证监会《关于做好公开募集证券投资基金投资顾问业务试点工作的通知》，试点机构从事基金投资顾问业务，应当按规定履行适当性义务，全面了解客户的情况，深入评估客户的风险识别能力、风险承受能力、投资目标，准确界定基金投资组合策略的风险特征，向客户提供符合其风险识别能力和承受能力的基金投资组合策略。</div>
                        <div class="noteText-div2">试点机构应当合理评估、准确界定基金投资组合策略的风险特征，法律法规对特定基金品种合格投资人范围又特别规定的，相关基金投资组合策略的风险特征不得低于有关规定。</div>
                        <div class="noteText-div2">本报告基金组合风险等级根据当前持仓信息计算，仅供参考。根据相关法律法规，建议至少每年重新评价基金组合风险，如遇市场环境重大变化、投资策略重要变更、组合成分基金显著调整等情形时应当及时更新。</div>
                        <div class="noteText-div2"><span style="font-weight: 600;">数据来源：</span> 晨星 (中国) </div>
                    </div>
                </div>
            </div>

            <div class="comeupRisk-desc2" v-show="fundTextList.length < 5">
                <div class="bottomlogo-div">
                    <div class="ms-newlogo"></div>
                </div>
                <div class="bottomtext-div">
                    <div class="bottomText-area">
                        <span class="comeupRisk-text">晨星（Morningstar）不保证信息的准确性、完整性和及时性，同时也不保证不会发生任何变更。此资料、数据、观点仅供参考，并不构成投资建议。在任何情况下，我公司不就本报告中的任何内容对任何投资行为做出任何形式的担保。本报告内容的版权归晨星资讯,(深圳)有限公司所有，未获得书面授权许可，不得以任何形式复制或用于制作报告、文件等用途。</span>
                    </div>
                </div>
            </div>

            <div class="zuhe-desc2" v-show="fundTextList.length > 4">
                <div class="zuhe-div1">
                    <span class="comeupRisk-title">组合持仓信息</span>
                </div>
                <div class="zuhe-div2">
                    <div class="msg-div">
                        <div class="msg-head">
                            <div class="head1">基金代码</div>
                            <div class="head2">基金名称</div>
                            <div class="head3">基金类型</div>
                            <div class="head4">晨星评级(三年)</div>
                            <div class="head5">风险等级</div>
                            <div class="head6">持仓比例(%)</div>
                        </div>
                        <div class="msg-content"  v-for="(item,index) in fundTextList.slice(4,31)" :key="index">
                            <div class="head1" style="font-weight: 545;font-size: 14px;">{{item.symbol}}</div>
                            <div class="head2" style="font-weight: 545;font-size: 14px;">{{item.symbolInfo.slice(7,100)}}</div>
                            <div class="head3" style="font-weight: 545;font-size: 14px;">{{item.type}}</div>
                            <div class="head4" style="font-weight: 545;font-size: 14px;">
                                <div class="msg-star" v-if="item.rank === '1'">
                                    <div class="star"></div>
                                </div>
                                <div class="msg-star" v-else-if="item.rank === '2'">
                                    <div class="star"></div>
                                    <div class="star"></div>
                                </div>
                                <div class="msg-star" v-else-if="item.rank === '3'">
                                    <div class="star"></div>
                                    <div class="star"></div>
                                    <div class="star"></div>
                                </div>
                                <div class="msg-star" v-else-if="item.rank === '4'">
                                    <div class="star"></div>
                                    <div class="star"></div>
                                    <div class="star"></div>
                                    <div class="star"></div>
                                </div>
                                <div class="msg-star" v-else-if="item.rank === '5'">
                                    <div class="star"></div>
                                    <div class="star"></div>
                                    <div class="star"></div>
                                    <div class="star"></div>
                                    <div class="star"></div>
                                </div>
                                <div v-else>
                                    {{item.rank}}
                                </div>
                            </div>
                            <div class="head5" style="font-weight: 545;font-size: 14px;">{{item.level}}</div>
                            <div class="head6" style="font-weight: 545;font-size: 14px;">{{parseFloat(item.weight).toFixed(2)}}</div>
                            <!-- <div class="head6" style="font-weight: 100;">{{item.num}}</div> -->
                            <!-- </div> -->
                        </div>
                    </div>
                    <div class="msDate-area2" v-show="fundTextList.length > 4 && fundTextList.length < 23">
                        <div class="msDate-div">风险等级更新日期：{{riskDate}}</div>
                        <div class="msDate-div">晨星评级更新日期：{{ratingDate}}</div>
                    </div>
                </div>
            </div>

            <div class="note-desc2" v-show="fundTextList.length > 4 && fundTextList.length < 23">
                <div class="note-title">
                    <span class="comeupRisk-title">备注</span>
                </div>
                <div class="note-text">
                    <div class="noteText-area">
                        <div class="noteText-div1">根据中国证监会《关于做好公开募集证券投资基金投资顾问业务试点工作的通知》，试点机构从事基金投资顾问业务，应当按规定履行适当性义务，全面了解客户的情况，深入评估客户的风险识别能力、风险承受能力、投资目标，准确界定基金投资组合策略的风险特征，向客户提供符合其风险识别能力和承受能力的基金投资组合策略。</div>
                        <div class="noteText-div2">试点机构应当合理评估、准确界定基金投资组合策略的风险特征，法律法规对特定基金品种合格投资人范围又特别规定的，相关基金投资组合策略的风险特征不得低于有关规定。</div>
                        <div class="noteText-div2">本报告基金组合风险等级根据当前持仓信息计算，仅供参考。根据相关法律法规，建议至少每年重新评价基金组合风险，如遇市场环境重大变化、投资策略重要变更、组合成分基金显著调整等情形时应当及时更新。</div>
                        <div class="noteText-div2"><span style="font-weight: 600;">数据来源：</span> 晨星 (中国) </div>
                    </div>
                </div>
            </div>

            <div class="msDate-area3" v-show="fundTextList.length > 22 && fundTextList.length < 31">
                        <div class="msDate-div">风险等级更新日期：{{riskDate}}</div>
                        <div class="msDate-div">晨星评级更新日期：{{ratingDate}}</div>
            </div>

            <div class="comeupRisk-desc3" v-show="fundTextList.length > 4 && fundTextList.length < 23">
                <div class="bottomlogo-div">
                    <div class="ms-newlogo"></div>
                </div>
                <div class="bottomtext-div">
                    <div class="bottomText-area">
                        <span class="comeupRisk-text">晨星（Morningstar）不保证信息的准确性、完整性和及时性，同时也不保证不会发生任何变更。此资料、数据、观点仅供参考，并不构成投资建议。在任何情况下，我公司不就本报告中的任何内容对任何投资行为做出任何形式的担保。本报告内容的版权归晨星资讯,(深圳)有限公司所有，未获得书面授权许可，不得以任何形式复制或用于制作报告、文件等用途。</span>
                    </div>
                </div>
            </div>

            <div class="comeupRisk-desc4" v-show="fundTextList.length > 22">
                <div class="bottomlogo-div">
                    <div class="ms-newlogo"></div>
                </div>
                <div class="bottomtext-div">
                    <div class="bottomText-area">
                        <span class="comeupRisk-text">晨星（Morningstar）不保证信息的准确性、完整性和及时性，同时也不保证不会发生任何变更。此资料、数据、观点仅供参考，并不构成投资建议。在任何情况下，我公司不就本报告中的任何内容对任何投资行为做出任何形式的担保。本报告内容的版权归晨星资讯,(深圳)有限公司所有，未获得书面授权许可，不得以任何形式复制或用于制作报告、文件等用途。</span>
                    </div>
                </div>
            </div>

            <div class="head-area" v-show="fundTextList.length > 22">
                <div class="head-content">
                    <span class="head-date">报告生成日期：{{currentDate}}</span>
                    <span class="head-title">{{reportName}}基金组合报告</span>
                </div>
                <div class="logo-img" />
            </div>

            <div class="note-desc3" v-show="fundTextList.length > 22 && fundTextList.length < 31">
                <div class="note-title">
                    <span class="comeupRisk-title">备注</span>
                </div>
                <div class="note-text">
                    <div class="noteText-area">
                        <div class="noteText-div1">根据中国证监会《关于做好公开募集证券投资基金投资顾问业务试点工作的通知》，试点机构从事基金投资顾问业务，应当按规定履行适当性义务，全面了解客户的情况，深入评估客户的风险识别能力、风险承受能力、投资目标，准确界定基金投资组合策略的风险特征，向客户提供符合其风险识别能力和承受能力的基金投资组合策略。</div>
                        <div class="noteText-div2">试点机构应当合理评估、准确界定基金投资组合策略的风险特征，法律法规对特定基金品种合格投资人范围又特别规定的，相关基金投资组合策略的风险特征不得低于有关规定。</div>
                        <div class="noteText-div2">本报告基金组合风险等级根据当前持仓信息计算，仅供参考。根据相关法律法规，建议至少每年重新评价基金组合风险，如遇市场环境重大变化、投资策略重要变更、组合成分基金显著调整等情形时应当及时更新。</div>
                        <div class="noteText-div2"><span style="font-weight: 600;">数据来源：</span> 晨星 (中国) </div>
                    </div>
                </div>
            </div>

            <div class="zuhe-desc2" v-show="fundTextList.length > 31">
                <div class="zuhe-div1">
                    <span class="comeupRisk-title">组合持仓信息</span>
                </div>
                <div class="zuhe-div2">
                    <div class="msg-div">
                        <div class="msg-head">
                            <div class="head1">基金代码</div>
                            <div class="head2">基金名称</div>
                            <div class="head3">基金类型</div>
                            <div class="head4">晨星评级(三年)</div>
                            <div class="head5">风险等级</div>
                            <div class="head6">持仓比例(%)</div>
                        </div>
                        <div class="msg-content"  v-for="(item,index) in fundTextList.slice(31,57)" :key="index">
                            <div class="head1" style="font-weight: 545;font-size: 14px;">{{item.symbol}}</div>
                            <div class="head2" style="font-weight: 545;font-size: 14px;">{{item.symbolInfo.slice(7,100)}}</div>
                            <div class="head3" style="font-weight: 545;font-size: 14px;">{{item.type}}</div>
                            <div class="head4" style="font-weight: 545;font-size: 14px;">
                                <div class="msg-star" v-if="item.rank === '1'">
                                    <div class="star"></div>
                                </div>
                                <div class="msg-star" v-else-if="item.rank === '2'">
                                    <div class="star"></div>
                                    <div class="star"></div>
                                </div>
                                <div class="msg-star" v-else-if="item.rank === '3'">
                                    <div class="star"></div>
                                    <div class="star"></div>
                                    <div class="star"></div>
                                </div>
                                <div class="msg-star" v-else-if="item.rank === '4'">
                                    <div class="star"></div>
                                    <div class="star"></div>
                                    <div class="star"></div>
                                    <div class="star"></div>
                                </div>
                                <div class="msg-star" v-else-if="item.rank === '5'">
                                    <div class="star"></div>
                                    <div class="star"></div>
                                    <div class="star"></div>
                                    <div class="star"></div>
                                    <div class="star"></div>
                                </div>
                                <div v-else>
                                    {{item.rank}}
                                </div>
                            </div>
                            <div class="head5" style="font-weight: 545;font-size: 14px;">{{item.level}}</div>
                            <div class="head6" style="font-weight: 545;font-size: 14px;">{{parseFloat(item.weight).toFixed(2)}}</div>
                            <!-- <div class="head6" style="font-weight: 100;">{{item.num}}</div> -->
                            <!-- </div> -->
                        </div>
                    </div>
                    <div class="msDate-area2" v-show="fundTextList.length > 4 && fundTextList.length < 23">
                        <div class="msDate-div">风险等级更新日期：{{riskDate}}</div>
                        <div class="msDate-div">晨星评级更新日期：{{ratingDate}}</div>
                    </div>
                </div>
            </div>

            <div class="msDate-area4" v-show="fundTextList.length > 30 && fundTextList.length < 50">
                        <div class="msDate-div">风险等级更新日期：{{riskDate}}</div>
                        <div class="msDate-div">晨星评级更新日期：{{ratingDate}}</div>
            </div>

            <div class="note-desc4" v-show="fundTextList.length > 30 && fundTextList.length < 50">
                <div class="note-title">
                    <span class="comeupRisk-title">备注</span>
                </div>
                <div class="note-text">
                    <div class="noteText-area">
                        <div class="noteText-div1">根据中国证监会《关于做好公开募集证券投资基金投资顾问业务试点工作的通知》，试点机构从事基金投资顾问业务，应当按规定履行适当性义务，全面了解客户的情况，深入评估客户的风险识别能力、风险承受能力、投资目标，准确界定基金投资组合策略的风险特征，向客户提供符合其风险识别能力和承受能力的基金投资组合策略。</div>
                        <div class="noteText-div2">试点机构应当合理评估、准确界定基金投资组合策略的风险特征，法律法规对特定基金品种合格投资人范围又特别规定的，相关基金投资组合策略的风险特征不得低于有关规定。</div>
                        <div class="noteText-div2">本报告基金组合风险等级根据当前持仓信息计算，仅供参考。根据相关法律法规，建议至少每年重新评价基金组合风险，如遇市场环境重大变化、投资策略重要变更、组合成分基金显著调整等情形时应当及时更新。</div>
                        <div class="noteText-div2"><span style="font-weight: 600;">数据来源：</span> 晨星 (中国) </div>
                    </div>
                </div>
            </div>

            <div class="comeupRisk-desc5" v-show="fundTextList.length > 30 && fundTextList.length < 50">
                <div class="bottomlogo-div">
                    <div class="ms-newlogo"></div>
                </div>
                <div class="bottomtext-div">
                    <div class="bottomText-area">
                        <span class="comeupRisk-text">晨星（Morningstar）不保证信息的准确性、完整性和及时性，同时也不保证不会发生任何变更。此资料、数据、观点仅供参考，并不构成投资建议。在任何情况下，我公司不就本报告中的任何内容对任何投资行为做出任何形式的担保。本报告内容的版权归晨星资讯,(深圳)有限公司所有，未获得书面授权许可，不得以任何形式复制或用于制作报告、文件等用途。</span>
                    </div>
                </div>
            </div>

            <div class="msDate-area5" v-show="fundTextList.length > 49 && fundTextList.length < 58">
                        <div class="msDate-div">风险等级更新日期：{{riskDate}}</div>
                        <div class="msDate-div">晨星评级更新日期：{{ratingDate}}</div>
            </div>

            <div class="comeupRisk-desc6" v-show="fundTextList.length > 49">
                <div class="bottomlogo-div">
                    <div class="ms-newlogo"></div>
                </div>
                <div class="bottomtext-div">
                    <div class="bottomText-area">
                        <span class="comeupRisk-text">晨星（Morningstar）不保证信息的准确性、完整性和及时性，同时也不保证不会发生任何变更。此资料、数据、观点仅供参考，并不构成投资建议。在任何情况下，我公司不就本报告中的任何内容对任何投资行为做出任何形式的担保。本报告内容的版权归晨星资讯,(深圳)有限公司所有，未获得书面授权许可，不得以任何形式复制或用于制作报告、文件等用途。</span>
                    </div>
                </div>
            </div>

            <div class="comeupRisk-desc7" v-show="fundTextList.length > 22 && fundTextList.length < 31">
                <div class="bottomlogo-div">
                    <div class="ms-newlogo"></div>
                </div>
                <div class="bottomtext-div">
                    <div class="bottomText-area">
                        <span class="comeupRisk-text">晨星（Morningstar）不保证信息的准确性、完整性和及时性，同时也不保证不会发生任何变更。此资料、数据、观点仅供参考，并不构成投资建议。在任何情况下，我公司不就本报告中的任何内容对任何投资行为做出任何形式的担保。本报告内容的版权归晨星资讯,(深圳)有限公司所有，未获得书面授权许可，不得以任何形式复制或用于制作报告、文件等用途。</span>
                    </div>
                </div>
            </div>

            <div class="head-area" v-show="fundTextList.length > 49">
                <div class="head-content">
                    <span class="head-date">报告生成日期：{{currentDate}}</span>
                    <span class="head-title">{{reportName}}基金组合报告</span>
                </div>
                <div class="logo-img" />
            </div>

            <div class="note-desc6" v-show="fundTextList.length > 49 && fundTextList.length < 58">
                <div class="note-title">
                    <span class="comeupRisk-title">备注</span>
                </div>
                <div class="note-text">
                    <div class="noteText-area">
                        <div class="noteText-div1">根据中国证监会《关于做好公开募集证券投资基金投资顾问业务试点工作的通知》，试点机构从事基金投资顾问业务，应当按规定履行适当性义务，全面了解客户的情况，深入评估客户的风险识别能力、风险承受能力、投资目标，准确界定基金投资组合策略的风险特征，向客户提供符合其风险识别能力和承受能力的基金投资组合策略。</div>
                        <div class="noteText-div2">试点机构应当合理评估、准确界定基金投资组合策略的风险特征，法律法规对特定基金品种合格投资人范围又特别规定的，相关基金投资组合策略的风险特征不得低于有关规定。</div>
                        <div class="noteText-div2">本报告基金组合风险等级根据当前持仓信息计算，仅供参考。根据相关法律法规，建议至少每年重新评价基金组合风险，如遇市场环境重大变化、投资策略重要变更、组合成分基金显著调整等情形时应当及时更新。</div>
                        <div class="noteText-div2"><span style="font-weight: 600;">数据来源：</span> 晨星 (中国) </div>
                    </div>
                </div>
            </div>

            <div class="comeupRisk-desc8" v-show="fundTextList.length > 49 && fundTextList.length < 58">
                <div class="bottomlogo-div">
                    <div class="ms-newlogo"></div>
                </div>
                <div class="bottomtext-div">
                    <div class="bottomText-area">
                        <span class="comeupRisk-text">晨星（Morningstar）不保证信息的准确性、完整性和及时性，同时也不保证不会发生任何变更。此资料、数据、观点仅供参考，并不构成投资建议。在任何情况下，我公司不就本报告中的任何内容对任何投资行为做出任何形式的担保。本报告内容的版权归晨星资讯,(深圳)有限公司所有，未获得书面授权许可，不得以任何形式复制或用于制作报告、文件等用途。</span>
                    </div>
                </div>
            </div>

            <div class="zuhe-desc3" v-show="fundTextList.length > 57">
                <div class="zuhe-div1">
                    <span class="comeupRisk-title">组合持仓信息</span>
                </div>
                <div class="zuhe-div2">
                    <div class="msg-div">
                        <div class="msg-head">
                            <div class="head1">基金代码</div>
                            <div class="head2">基金名称</div>
                            <div class="head3">基金类型</div>
                            <div class="head4">晨星评级(三年)</div>
                            <div class="head5">风险等级</div>
                            <div class="head6">持仓比例(%)</div>
                        </div>
                        <div class="msg-content"  v-for="(item,index) in fundTextList.slice(57,85)" :key="index">
                            <div class="head1" style="font-weight: 545;font-size: 14px;">{{item.symbol}}</div>
                            <div class="head2" style="font-weight: 545;font-size: 14px;">{{item.symbolInfo.slice(7,100)}}</div>
                            <div class="head3" style="font-weight: 545;font-size: 14px;">{{item.type}}</div>
                            <div class="head4" style="font-weight: 545;font-size: 14px;">
                                <div class="msg-star" v-if="item.rank === '1'">
                                    <div class="star"></div>
                                </div>
                                <div class="msg-star" v-else-if="item.rank === '2'">
                                    <div class="star"></div>
                                    <div class="star"></div>
                                </div>
                                <div class="msg-star" v-else-if="item.rank === '3'">
                                    <div class="star"></div>
                                    <div class="star"></div>
                                    <div class="star"></div>
                                </div>
                                <div class="msg-star" v-else-if="item.rank === '4'">
                                    <div class="star"></div>
                                    <div class="star"></div>
                                    <div class="star"></div>
                                    <div class="star"></div>
                                </div>
                                <div class="msg-star" v-else-if="item.rank === '5'">
                                    <div class="star"></div>
                                    <div class="star"></div>
                                    <div class="star"></div>
                                    <div class="star"></div>
                                    <div class="star"></div>
                                </div>
                                <div v-else>
                                    {{item.rank}}
                                </div>
                            </div>
                            <div class="head5" style="font-weight: 545;font-size: 14px;">{{item.level}}</div>
                            <div class="head6" style="font-weight: 545;font-size: 14px;">{{parseFloat(item.weight).toFixed(2)}}</div>
                        </div>
                    </div>
                    <div class="msDate-area2" v-show="fundTextList.length > 4 && fundTextList.length < 23">
                        <div class="msDate-div">风险等级更新日期：{{riskDate}}</div>
                        <div class="msDate-div">晨星评级更新日期：{{ratingDate}}</div>
                    </div>
                </div>
            </div>

            <div class="msDate-area9" v-show="fundTextList.length > 57">
                        <div class="msDate-div">风险等级更新日期：{{riskDate}}</div>
                        <div class="msDate-div">晨星评级更新日期：{{ratingDate}}</div>
            </div>            

            <div class="note-desc9" v-show="fundTextList.length > 57">
                <div class="note-title">
                    <span class="comeupRisk-title">备注</span>
                </div>
                <div class="note-text">
                    <div class="noteText-area">
                        <div class="noteText-div1">根据中国证监会《关于做好公开募集证券投资基金投资顾问业务试点工作的通知》，试点机构从事基金投资顾问业务，应当按规定履行适当性义务，全面了解客户的情况，深入评估客户的风险识别能力、风险承受能力、投资目标，准确界定基金投资组合策略的风险特征，向客户提供符合其风险识别能力和承受能力的基金投资组合策略。</div>
                        <div class="noteText-div2">试点机构应当合理评估、准确界定基金投资组合策略的风险特征，法律法规对特定基金品种合格投资人范围又特别规定的，相关基金投资组合策略的风险特征不得低于有关规定。</div>
                        <div class="noteText-div2">本报告基金组合风险等级根据当前持仓信息计算，仅供参考。根据相关法律法规，建议至少每年重新评价基金组合风险，如遇市场环境重大变化、投资策略重要变更、组合成分基金显著调整等情形时应当及时更新。</div>
                        <div class="noteText-div2"><span style="font-weight: 600;">数据来源：</span> 晨星 (中国) </div>
                    </div>
                </div>
            </div>

            <div class="comeupRisk-desc9" v-show="fundTextList.length > 57">
                <div class="bottomlogo-div">
                    <div class="ms-newlogo"></div>
                </div>
                <div class="bottomtext-div">
                    <div class="bottomText-area">
                        <span class="comeupRisk-text">晨星（Morningstar）不保证信息的准确性、完整性和及时性，同时也不保证不会发生任何变更。此资料、数据、观点仅供参考，并不构成投资建议。在任何情况下，我公司不就本报告中的任何内容对任何投资行为做出任何形式的担保。本报告内容的版权归晨星资讯,(深圳)有限公司所有，未获得书面授权许可，不得以任何形式复制或用于制作报告、文件等用途。</span>
                    </div>
                </div>
            </div>

        </div>
        </div>
        <br />
    </el-row>
</template>
<script>
import { Message } from "element-ui";
import { portfolioRisk } from "../../api/portfolio";
import { getFundCache } from "../../api/portfolio";
import { getFundRiskLevelParam } from "../../api/portfolio";
import XLSX from "xlsx";
import Vue from 'vue';

const componentsCommon=require("cb-components-common").default;
const getCurrentDate=componentsCommon.common.getCurrentDate;
const checkResponseStatus=componentsCommon.common.checkResponseStatus;
const getDateByStandardFormat=componentsCommon.common.getDateByStandardFormat;
const openDownloadDialog=componentsCommon.downloadUtils.openDownloadDialog;
const sheet2blob=componentsCommon.downloadUtils.sheet2blob;
const searchBox=componentsCommon.mixin.searchBox.searchBox;
const getNameAndValue=componentsCommon.localStorage.getNameAndValue;

import htmlToPdf from '../../api/htmlToPdf';
import RiskScale from './RiskScale.vue';

export default {
    mixins: [searchBox],
    components: {
        RiskScale,
    },
    data() {
        return {
            
            taskSteps: [{
                taskName:"步骤一",
                taskId:1
            },{
                taskName:"步骤二",
                taskId:2
            }
            ],

            show1Div: true,
            show2Div: false,
            show3Div: false,
            showIn: false, // 控制滑动动画
            showOut: false, // 控制滑动动画
            stepIndex: 0,
            withoutSmallStepData: [
            {
                id: 1,
                title: '创建组合',
                active: true,
            },
            {
                id: 2,
                title: '持仓信息',
                active: false,
            },
            {
                id: 3,
                title: '诊断结果',
                active: false,
            }
            ],

            marginLeft: '1150px',

            positionRiskScore: "0",
            morningstarRiskLevel: "0",
            standardDeviationLevel: "0",
            downsideDeviationLevel: "0",
            additionalScaleScore: "0",
            totalRiskText: "0",
            //circle
            positionRiskScore_marginLeftCircleProcess: '0px',
            morningstarRiskLevel_marginLeftCircleProcess: '0px',
            standardDeviationLevel_marginLeftCircleProcess: '0px',
            downsideDeviationLevel_marginLeftCircleProcess: '0px',
            additionalScaleScore_marginLeftCircleProcess: '0px',
            //squre
            positionRiskScore_marginLeftSquProcess: '0px',
            downsideDeviationLevel_marginLeftSquProcess: '0px',
            morningstarRiskLevel_marginLeftSquProcess: '0px',
            additionalScaleScore_marginLeftSquProcess: '0px',
            standardDeviationLevel_marginLeftSquProcess: '0px',
            showForwardButton: false,
            showNextButton: true,
            nextStepText: '输入持仓',
            procseeSquType: "process-step1",
            procseeCircleBigType: "process-circle-big",
            processCircleSmallType: "process-circle-small",


            resultText: '0',

            notYetShow1: true,
            isOkShow2: false,
            pointShow3: false,
            notYetShow4: false,
            isOkShow5: false,
            pointShow6: true,
            notYetShow7: false,
            isOkShow8: false,
            pointShow9: true,
            lineShow1: true,
            lineShow2: false,

            riskCss: "portfolio_image_risk1",
            loading: false,
            totalRisk: "",
            index: 0,
            searchPopoverVisible: [],
            isShowResult: false,
            portfolioDate: "",
            rebalanceFrequency: "buyandhold",
            isChangeRisk: false,
            lastRisk: "1",
            fundList: [],
            portfolioRatio: 0,
            tableKey: 1,
            fileList: [],
            symbolIdList: "",
            positionRiskScore_percentage: 0,
            morningstarRiskLevel_percentage: 0,
            standardDeviationLevel_percentage: 0,
            downsideDeviationLevel_percentage: 0,
            totalRisk_percentage: 0,
            additionalScaleScore_percentage: 0,
            calculateFundDateGtThreeYearPercent: "",
            isSelectedEFAF: false,
            portfolioSuitabilityMemberSenior: false,
            portfolioSuitabilityMemberBase: false,
            riskDate: "",
            ratingDate: "",

            currentDate: "",
            reportName: '',
            reportCode: "",
            selectDate: "",
            counselor: "",
            allRiskType: '',
            balanceDateText: '买入并持有',
            yjNotMoreText: '无',
            UpRiskLevelText: '无',
            riskLevelText: '否',
            qyFundText: '否',
            fundTextList: [],
            clickFlag: false,
            reportFlag: false,
            input1: '--',
			input2: '--',
			input3: '--',
			input4: '--',
			input5: '--',
			input6: '--',
			input7: '--'
        };
    },
    mounted() {
        this.initData();
        this.getTodayDate();
        this.getUserInfo();
    },
    updated() {
        // this.$refs.floatPanel.style.width =
        //     document.getElementsByClassName("mainContent")[0].offsetWidth +
        //     "px";

        if(this.portfolioDate === "") {
            var aData = new Date();
            this.selectDate = aData.getFullYear() + "年" + (aData.getMonth() + 1) + "月" + aData.getDate()+"日";
        } else {
            this.selectDate = this.portfolioDate.getFullYear() + "年" + (this.portfolioDate.getMonth() + 1) + "月" + this.portfolioDate.getDate()+"日";
        }

        if (this.reportName !== '') {
            this.reportName = this.reportName;
        }
        if (this.reportCode !== '') {
            this.reportCode = this.reportCode;
        }
        if (this.counselor !== '') {
            this.counselor = this.counselor;
        }

        this.yjNotMoreText = this.calculateFundDateGtThreeYearPercent;

        //设置为点击了计算按钮再重新渲染
        if (this.clickFlag) {
            this.allRiskType = this.allRiskType;
            this.positionRiskScore_percentage = this.positionRiskScore_percentage;
            this.morningstarRiskLevel_percentage = this.morningstarRiskLevel_percentage;
            this.standardDeviationLevel_percentage = this.standardDeviationLevel_percentage;
            this.downsideDeviationLevel_percentage = this.downsideDeviationLevel_percentage;
            this.totalRisk_percentage = this.totalRisk_percentage;
            this.additionalScaleScore_percentage = this.additionalScaleScore_percentage;

            this.input1 = this.calculateRiskLevel(this.allRiskType);
            this.input2 = this.calculatePercentage(this.positionRiskScore_percentage);
            this.input3 = this.calculatePercentage(this.morningstarRiskLevel_percentage);
            this.input4 = this.calculatePercentage(this.standardDeviationLevel_percentage);
            this.input5 = this.calculatePercentage(this.downsideDeviationLevel_percentage);
            this.input6 = this.calculatePercentage(this.additionalScaleScore_percentage);
            this.input7 = this.calculateRiskType(this.allRiskType);
            this.fundTextList = this.fundList;
            // this.fundTextList = this.fundTextList;

            //以下是处理小数位的方法:
        //>1表示有小数位，else无小数位则什么都不做保持初始位置
        if (this.positionRiskScore.length > 1) {
            var index = this.positionRiskScore.lastIndexOf(".");
            var num1 = this.positionRiskScore.substr(index+1,this.positionRiskScore.length);
            //获取整数位
            var num2 = this.positionRiskScore.substr(0,index);
            //以防出现两位小数的情况
            if (num1.length == 1) {
                var positionNum = this.positionRiskScore.substr(index+1,this.positionRiskScore.length);//该方法可获取一位小数的小数数字
                //接下来将获取的小数位positionNum转为小圆圈的位移(最大为35px,每格为3.5px)
                this.positionRiskScore_marginLeftCircleProcess = this.calcuateCircleProcessPx(positionNum);
            }
            if (num1.length == 2) {
                var positionNum = this.positionRiskScore.substr(index+1,this.positionRiskScore.length);//该方法可获取两位小数的第一位小数数字
                //接下来将获取的小数位positionNum转为小圆圈的位移(例如44px为1)
                this.positionRiskScore_marginLeftCircleProcess = this.calcuateCircleProcessPx(positionNum.substr(0,1));
            }
            this.positionRiskScore_marginLeftSquProcess = this.calcuateSquProcessPx(num2);
        } else {
            if (this.positionRiskScore != "0") {
                var num2 = this.positionRiskScore.substr(0,1);
                this.positionRiskScore_marginLeftSquProcess = this.calcuateSquProcessPx(num2);
                this.positionRiskScore_marginLeftCircleProcess = '0px';
            }
        }
        if (this.morningstarRiskLevel.length > 1) {
            var index = this.morningstarRiskLevel.lastIndexOf(".");
            var num1 = this.morningstarRiskLevel.substr(index+1,this.morningstarRiskLevel.length);
            //获取整数位
            var num2 = this.morningstarRiskLevel.substr(0,index);
            //以防出现两位小数的情况
            if (num1.length == 1) {
                var positionNum = this.morningstarRiskLevel.substr(index+1,this.morningstarRiskLevel.length);//该方法可获取一位小数的小数数字
                //接下来将获取的小数位positionNum转为小圆圈的位移(最大为35px,每格为3.5px)
                this.morningstarRiskLevel_marginLeftCircleProcess = this.calcuateCircleProcessPx(positionNum);
            }
            if (num1.length == 2) {
                var positionNum = this.morningstarRiskLevel.substr(index+1,this.morningstarRiskLevel.length);//该方法可获取两位小数的第一位小数数字
                //接下来将获取的小数位positionNum转为小圆圈的位移(例如44px为1)
                this.morningstarRiskLevel_marginLeftCircleProcess = this.calcuateCircleProcessPx(positionNum.substr(0,1));
            }
            this.morningstarRiskLevel_marginLeftSquProcess = this.calcuateSquProcessPx(num2);
        } else {
            if (this.morningstarRiskLevel != "0") {
                var num2 = this.morningstarRiskLevel.substr(0,1);
                this.morningstarRiskLevel_marginLeftSquProcess = this.calcuateSquProcessPx(num2);
                this.morningstarRiskLevel_marginLeftCircleProcess = '0px';
            }
        }
        if (this.standardDeviationLevel.length > 1) {
            var index = this.standardDeviationLevel.lastIndexOf(".");
            var num1 = this.standardDeviationLevel.substr(index+1,this.standardDeviationLevel.length);
            //获取整数位
            var num2 = this.standardDeviationLevel.substr(0,index);
            //以防出现两位小数的情况
            if (num1.length == 1) {
                var positionNum = this.standardDeviationLevel.substr(index+1,this.standardDeviationLevel.length);//该方法可获取一位小数的小数数字
                //接下来将获取的小数位positionNum转为小圆圈的位移(最大为35px,每格为3.5px)
                this.standardDeviationLevel_marginLeftCircleProcess = this.calcuateCircleProcessPx(positionNum);
            }
            if (num1.length == 2) {
                var positionNum = this.standardDeviationLevel.substr(index+1,this.standardDeviationLevel.length);//该方法可获取两位小数的第一位小数数字
                //接下来将获取的小数位positionNum转为小圆圈的位移(例如44px为1)
                this.standardDeviationLevel_marginLeftCircleProcess = this.calcuateCircleProcessPx(positionNum.substr(0,1));
            }
            this.standardDeviationLevel_marginLeftSquProcess = this.calcuateSquProcessPx(num2);
        } else {
            if (this.standardDeviationLevel != "0") {
                var num2 = this.standardDeviationLevel.substr(0,1);
                this.standardDeviationLevel_marginLeftSquProcess = this.calcuateSquProcessPx(num2);
                this.standardDeviationLevel_marginLeftCircleProcess = '0px';
            }
        }
        if (this.downsideDeviationLevel.length > 1) {
            var index = this.downsideDeviationLevel.lastIndexOf(".");
            var num1 = this.downsideDeviationLevel.substr(index+1,this.downsideDeviationLevel.length);
            //获取整数位
            var num2 = this.downsideDeviationLevel.substr(0,index);
            //以防出现两位小数的情况
            if (num1.length == 1) {
                var positionNum = this.downsideDeviationLevel.substr(index+1,this.downsideDeviationLevel.length);//该方法可获取一位小数的小数数字
                //接下来将获取的小数位positionNum转为小圆圈的位移(最大为35px,每格为3.5px)
                this.downsideDeviationLevel_marginLeftCircleProcess = this.calcuateCircleProcessPx(positionNum);
            }
            if (num1.length == 2) {
                var positionNum = this.downsideDeviationLevel.substr(index+1,this.downsideDeviationLevel.length);//该方法可获取两位小数的第一位小数数字
                //接下来将获取的小数位positionNum转为小圆圈的位移(例如44px为1)
                this.downsideDeviationLevel_marginLeftCircleProcess = this.calcuateCircleProcessPx(positionNum.substr(0,1));
            }
            this.downsideDeviationLevel_marginLeftSquProcess = this.calcuateSquProcessPx(num2);
        } else {
            if (this.downsideDeviationLevel != "0") {
                var num2 = this.downsideDeviationLevel.substr(0,1);
                this.downsideDeviationLevel_marginLeftSquProcess = this.calcuateSquProcessPx(num2);
                this.downsideDeviationLevel_marginLeftCircleProcess = '0px';
            }
        }
        if (this.additionalScaleScore.length > 1) {
            var index = this.additionalScaleScore.lastIndexOf(".");
            var num1 = this.additionalScaleScore.substr(index+1,this.additionalScaleScore.length);
            //获取整数位
            var num2 = this.additionalScaleScore.substr(0,index);
            //以防出现两位小数的情况
            if (num1.length == 1) {
                var positionNum = this.additionalScaleScore.substr(index+1,this.additionalScaleScore.length);//该方法可获取一位小数的小数数字
                this.additionalScaleScore_marginLeftCircleProcess = this.calcuateCircleProcessPx(positionNum);
            }
            if (num1.length == 2) {
                var positionNum = this.additionalScaleScore.substr(index+1,this.additionalScaleScore.length);//该方法可获取两位小数的第一位小数数字
                this.additionalScaleScore_marginLeftCircleProcess = this.calcuateCircleProcessPx(positionNum.substr(0,1));
            }
            this.additionalScaleScore_marginLeftSquProcess = this.calcuateSquProcessPx(num2);
        } else {
            if (this.additionalScaleScore != "0") {
                var num2 = this.additionalScaleScore.substr(0,1);
                this.additionalScaleScore_marginLeftSquProcess = this.calcuateSquProcessPx(num2);
                this.additionalScaleScore_marginLeftCircleProcess = '0px'; 
            }
        }

    }

        if (this.isChangeRisk) {
            this.riskLevelText = '是';
            if (this.lastRisk === '1') {
                this.UpRiskLevelText = "低风险 R1";
            } else if (this.lastRisk === '2') {
                this.UpRiskLevelText = "中低风险 R2";
            } else if (this.lastRisk === '3') {
                this.UpRiskLevelText = "中风险 R3";
            } else if (this.lastRisk === '4') {
                this.UpRiskLevelText = "中高风险 R4";
            } else if (this.lastRisk === '5') {
                this.UpRiskLevelText = "高风险 R5";
            }
        } else {
            this.riskLevelText = '否';
            this.UpRiskLevelText = "无";
        }
        if(this.isSelectedEFAF) {
            this.qyFundText = '是';
        } else {
            this.qyFundText = '否';
        }

        if (this.rebalanceFrequency === 'buyandhold') {
            this.balanceDateText = "买入并持有";
        } else if (this.rebalanceFrequency === 'monthly') {
            this.balanceDateText = "月度";
        } else if (this.rebalanceFrequency === 'quarterly') {
            this.balanceDateText = "季度";
        } else if (this.rebalanceFrequency === 'semi-annually') {
            this.balanceDateText = "半年度";
        } else if (this.rebalanceFrequency === 'annually') {
            this.balanceDateText = "年度";
        }
    },
    methods: {
        handleDown(){
            if (this.clickFlag && this.reportFlag) {
                let str = "";
                if (this.fundTextList.length < 5) {
                    str = '#demo2';
                } else if (this.fundTextList.length > 4 && this.fundTextList.length < 23) {
                    str = '#demo2';
                } else if (this.fundTextList.length > 22 && this.fundTextList.length < 50){
                    str = '#demo3';
                } else {
                    str = '#demo4';
                }
                htmlToPdf.downloadPDF( document.querySelector(str),'基金组合风险报告');
            }
        },
        getUserInfo() {
            let userInfo = getNameAndValue("info");
            this.portfolioSuitabilityMemberSenior = JSON.parse(userInfo).portfolioSuitabilityMemberSenior;
            this.portfolioSuitabilityMemberBase = JSON.parse(userInfo).portfolioSuitabilityMemberBase;
        },
        calculatePercentage(allRiskTypeParam) {
            let num = ((allRiskTypeParam * 5) / 100).toFixed(2);
            let levelName = "";
            if (num >= 0 && num <= 1) {
                levelName = "低";
            } else if (num > 1 && num <= 2) {
                levelName = "中低";
            } else if (num > 2 && num <= 3) {
                levelName = "中";
            } else if (num > 3 && num <= 4) {
                levelName = "中高";
            } else if (num > 4 && num <= 5) {
                levelName = "高";
            }
            return levelName;
        },
        calculateRiskType(num) {
            let typeName = "";
            if (num >= 0 && num <= 1) {
                typeName = "安益型(C1)";
            } else if (num > 1 && num <= 2) {
                typeName = "保守型(C2)";
            } else if (num > 2 && num <= 3) {
                typeName = "稳健型(C3)";
            } else if (num > 3 && num <= 4) {
                typeName = "积极型(C4)";
            } else if (num > 4 && num <= 5) {
                typeName = "激进型(C5)";
            }
            return typeName;
        },
        calculateRiskLevel(num) {
            let levelName = "";
            if (num >= 0 && num <= 1) {
                levelName = "低风险(R1)";
            } else if (num > 1 && num <= 2) {
                levelName = "中低风险(R2)";
            } else if (num > 2 && num <= 3) {
                levelName = "中风险(R3)";
            } else if (num > 3 && num <= 4) {
                levelName = "中高风险(R4)";
            } else if (num > 4 && num <= 5) {
                levelName = "高风险(R5)";
            }
            return levelName;
        },
        calcuateCircleProcessPx(num) {
            let processPx = "";
            if (num == 1) {
                processPx = "3.5px";
            } else if (num == 2) {
                processPx = "7px";
            } else if (num == 3) {
                processPx = "10.5px";
            } else if (num == 4) {
                processPx = "14px";
            } else if (num == 5) {
                processPx = "17.5px";
            } else if (num == 6) {
                processPx = "21px";
            } else if (num == 7) {
                processPx = "24.5px";
            } else if (num == 8) {
                processPx = "28px";
            } else if (num == 9) {
                processPx = "31.5px";
            } else {
                processPx = "0px";
            }
            return processPx;
        },
        calcuateSquProcessPx(num) {
            let processPx = "";
            if (num == 0) {
                processPx = "0px";
            } else if (num == 1) {
                processPx = "0px";
            } else if (num == 2) {
                processPx = "55px";
            } else if (num == 3) {
                processPx = "110px";
            } else if (num == 4) {
                processPx = "165px";
            } else if (num == 5) {
                processPx = "220px";
            }
            return processPx;
        },
        getTodayDate() {
            var aData = new Date();
            this.currentDate = aData.getFullYear() + "/" + (aData.getMonth() + 1) + "/" + aData.getDate();
        },
        cellStyle({ row, column, rowIndex, columnIndex }) {
            let index = rowIndex + 1;
            let styleString = "";
            if (index % 2 == 0) {
                styleString += "background-color: rgba(248, 250, 254, 1);";
            }

            return styleString;
        },

        getFundName(symbol, index) {
            var that = this;
            getFundCache({
                keyword: symbol
            })
            .then(response => {
                let result = response.data;
                if (result != undefined && checkResponseStatus(result, self)) {
                    var item = {}
                    item.symbol = that.fundList[index].symbol;
                    item.weight = that.fundList[index].weight;
                    item["symbolInfo"] = item["symbol"] + " " + result.data[0].name;
                    that.$set(that.fundList,index,item)
                }
            })
    
        },
        handleCalRatio() {
            this.portfolioRatio = 0;
            for (let i = 0; i < this.fundList.length; i++) {
                if (this.fundList[i].symbol) {
                    let ratio = this.fundList[i].weight;
                    if (ratio != "" && !isNaN(Number(ratio))) {
                        this.portfolioRatio += parseFloat(ratio);
                    }
                }
            }
            
            this.portfolioRatio = Number(
                String(this.portfolioRatio).replace(/^(.*\..{4}).*$/, "$1")
            );
        },
        handleFocus(index, event) {
            let self = this;
            self.tableIndex = index;
            event.currentTarget.select();
            //self.$refs["items_" + self.tableIndex].$refs.popper.hidden = false;
        },
        async handleCalculation() {
            let self = this;
            self.loading = true;
            let date = getCurrentDate();
            if (self.portfolioDate) {
                date = getDateByStandardFormat(self.portfolioDate);
            }
            let para = {
                portfolioDate: date,
                rebalanceFrequency: self.rebalanceFrequency,
                fundList: [],
            };
            let checkSameSymbol = new Array();
            let countWeigh = 0;
            let sumWeigh = 0;
            self.symbolIdList = "";
            for (let i = 0; i < self.fundList.length; i++) {
                let tempSymbol = self.fundList[i].symbol;
                let tempWeigh = self.fundList[i].weight;
                if (tempSymbol) {
                    checkSameSymbol[tempSymbol] = self.fundList[i].symbol;
                    para.fundList.push(self.fundList[i]);
                }
                if (tempWeigh) {
                    sumWeigh += parseFloat(tempWeigh);
                    countWeigh++;
                }
                self.symbolIdList += tempSymbol + ",";
            }

            for(let i = 0; i < self.fundList.length; i++) {
                if (self.fundList[0].symbol == "") {
                    break;
                }
                if (self.fundList[i].symbol == "") {
                    self.fundList.splice(i, 5);
                }
            }

            self.reportFlag = false;
            await getFundRiskLevelParam({
                symbolList: self.symbolIdList
            })
            .then(response => {
                let result = response.data;
                if (result != undefined && checkResponseStatus(result, self)) {
                    for (let i = 0; i < self.fundList.length; i++) {
                        for(let j = 0; j < self.fundList.length; j++) {
                            if (self.fundList[i].symbol == result.data.apiRiskLevelInfoLevelEntityList[j].symbol) {
                                self.fundList[i].level = "R"+result.data.apiRiskLevelInfoLevelEntityList[j].totalRisk;
                                self.fundList[i].type = result.data.apiRiskLevelInfoLevelEntityList[j].specialCategory;
                                self.fundList[i].rank = result.data.apiRiskLevelInfoLevelEntityList[j].starRating;
                            }
                        }
                    }
                }
                self.fundTextList = self.fundList;
                self.reportFlag = true;
            })

            let countSymbol = 0;
            for (let key of Object.keys(checkSameSymbol)) {
                countSymbol++;
            }
            if (self.isChangeRisk) {
                para.lastRisk = parseInt(self.lastRisk);
            }
            if(self.isSelectedEFAF) {
                para.isSelectEFAF = self.isSelectedEFAF;
            }
            sumWeigh = Number(String(sumWeigh).replace(/^(.*\..{4}).*$/, "$1"));
            if (sumWeigh < 99.995 || sumWeigh > 100.004) {
                Message({
                    message:
                        "权重分配需要超过99.995%并不大于100%，请调整再试！",
                    type: "error",
                    duration: 2 * 1000,
                });
                Message.close = function () {};
                self.loading = false;
                return false;
            }
            if (
                countSymbol != para.fundList.length ||
                countWeigh != para.fundList.length
            ) {
                Message({
                    message: "有相同Symbol或有权重未分配，请调整再试！",
                    type: "error",
                    duration: 2 * 1000,
                });
                Message.close = function () {};
                self.loading = false;
            } else {
                await portfolioRisk(para)
                    .then((response) => {
                        let result = response.data;
                        if (result == undefined) {
                            Message({
                                message: "数据异常，请尝试刷新再试！",
                                type: "error",
                                duration: 2 * 1000,
                            });
                            Message.close = function () {};
                        } else {
                            if (checkResponseStatus(result, self)) {
                                self.isShowResult = true;
                                switch (result.data.totalRisk) {
                                    case 1:
                                        self.totalRisk = "R1 低风险";
                                        self.riskCss = "portfolio_image_risk1";
                                        break;
                                    case 2:
                                        self.totalRisk = "R2 中低风险";
                                        self.riskCss = "portfolio_image_risk2";
                                        break;
                                    case 3:
                                        self.totalRisk = "R3 中风险";
                                        self.riskCss = "portfolio_image_risk3";
                                        break;
                                    case 4:
                                        self.totalRisk = "R4 中高风险";
                                        self.riskCss = "portfolio_image_risk4";
                                        break;
                                    case 5:
                                        self.totalRisk = "R5 高风险";
                                        self.riskCss = "portfolio_image_risk5";
                                        break;
                                }
                                self.allRiskType = result.data.totalRisk;

                                if (self.fundList.length > 1) {
                                        self.positionRiskScore_percentage = (
                                        (result.data.positionRiskScore / 5) *
                                        100
                                    ).toFixed(2);
                                    self.positionRiskScore = result.data.positionRiskScore.toFixed(1)+"";
                                    self.morningstarRiskLevel_percentage = (
                                        (result.data.morningstarRiskLevel / 5) *
                                        100
                                    ).toFixed(2);
                                    self.morningstarRiskLevel = result.data.morningstarRiskLevel.toFixed(1)+"";
                                    self.standardDeviationLevel_percentage = (
                                        (result.data.standardDeviationLevel / 5) *
                                        100
                                    ).toFixed(2);
                                    self.standardDeviationLevel = result.data.standardDeviationLevel.toFixed(1)+"";
                                    self.downsideDeviationLevel_percentage = (
                                        (result.data.downsideDeviationLevel / 5) *
                                        100
                                    ).toFixed(2);
                                    self.downsideDeviationLevel = result.data.downsideDeviationLevel.toFixed(1)+"";
                                    self.totalRisk_percentage = (
                                        (result.data.totalRisk / 5) *
                                        100
                                    ).toFixed(2);
                                    self.totalRiskText = result.data.totalRisk+"";
                                    self.additionalScaleScore_percentage = (
                                        (result.data.additionalScaleScore / 5) *
                                        100
                                    ).toFixed(2);
                                    self.procseeSquType = "process-step1";
                                    self.procseeCircleBigType = "process-circle-big";
                                    self.processCircleSmallType = "process-circle-small";
                                    self.additionalScaleScore = result.data.additionalScaleScore.toFixed(1)+"";
                                    self.calculateFundDateGtThreeYearPercent = result.data.calculateFundDateGtThreeYearPercent;
                                    self.riskDate = result.data.riskDate;
                                    self.ratingDate = result.data.ratingDate;
                                    self.clickFlag=true;
                                } else {
                                    self.totalRiskText = result.data.totalRisk+"";
                                    self.positionRiskScore = "--";
                                    self.downsideDeviationLevel = "--";
                                    self.morningstarRiskLevel = "--";
                                    self.additionalScaleScore = "--";
                                    self.standardDeviationLevel = "--";
                                    self.procseeSquType = "process-step2";
                                    self.procseeCircleBigType = "process-circle-big2";
                                    self.processCircleSmallType = "process-circle-small2";
                                    self.clickFlag=true;
                                }
                            }
                        }
                    })
                    .catch((err) => {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000,
                        });
                        Message.close = function () {};
                    })
                    .finally((r) => {
                        self.loading = false;
                        this.show2Div = !this.show2Div;
                        this.show3Div = !this.show3Div;
                        self.stepIndex = 2;
                        self.marginLeft = 0;
                        self.showForwardButton = true;
                        self.showNextButton = false;
                        return true;
                    });
            }
        },
        initData() {
            let self = this;
            if (self.fundList.length == 0) {
                for (let i = 0; i < 5; i++) {
                    self.fundList.push({
                        symbol: "",
                        weight: "",
                        symbolInfo: "",
                        type: "",
                        rank: "",
                        level: ""
                    });
                }
            }
        },
        handleAddRecord() {
            let self = this;
            self.tableKey = self.fundList.length;
            if (self.fundList.length < 50) {
                self.fundList.push({ symbol: "", weight: "", symbolInfo: "", type: "", rank: "", level: "" });
            } else {
                Message({
                    message: "添加失败，已超过50个基金数！",
                    type: "error",
                    duration: 2 * 1000,
                });
                Message.close = function () {};
            }
        },
        handleRemoveRecord(index) {
            let self = this;
            if (index == self.fundList.length -1) {
                self.tableKey = self.fundList.length;
                if (self.fundList.length < 50) {
                    self.fundList.push({ symbol: "", weight: "", symbolInfo: "", type: "", rank: "", level: "" });
                } else {
                Message({
                    message: "添加失败，已超过50个基金数！",
                    type: "error",
                    duration: 2 * 1000,
                });
                    Message.close = function () {};
                }
            } else {
                if (index < self.fundList.length) {
                    self.fundList.splice(index, 1);
                }
            }
        },
        handleResetRecord(index) {
            let self = this;
            self.fundList = [];
            this.initData();
        },
        handleAvg() {
            let countNum = 0;
            let avgList = [];
            for (let i = 0; i < this.fundList.length; i++) {
                if (this.fundList[i].symbol) {
                    this.fundList[i].weight = "";
                    countNum++;
                    avgList.push(this.fundList[i]);
                }
            }
            let avg = Number(
                String(100 / countNum).replace(/^(.*\..{4}).*$/, "$1")
            );
            for (let i = 0; i < avgList.length; i++) {
                avgList[i].weight = avg;
            }
            this.portfolioRatio = 100;
        },
        searchDataByAutoComplete(queryString, that) {
            const self = this;
            let results = self.symbolList;
            self.state.length = 0;
            self.state.push(
                "<span class='searchbox_symbol font_bold'>基金代码</span><span class='searchbox_title font_bold'>基金名称</span>"
            );
            if (results !== undefined) {
                for (let i = 0; i < results.length; i++) {
                    const value = results[i].symbol + "    " + results[i].name;
                    let htmlString = value.replace(
                        queryString,
                        "<b style='color:red;'>" + queryString + "</b>"
                    );
                    htmlString = htmlString.replace(
                        "    ",
                        "</span><span class='searchbox_title'>"
                    );
                    if (i === 0) {
                        self.firstSymbol = results[i].symbol;
                        self.state.push(
                            "<span class='searchbox_symbol'>" +
                                htmlString +
                                "</span>"
                        );
                    } else {
                        self.state.push(
                            "<span class='searchbox_symbol'>" +
                                htmlString +
                                "</span>"
                        );
                    }
                }
            }
            if (results === undefined || results.length === 0) {
                self.state.length = 0;
                self.state.push(
                    "<span class='font_bold'>抱歉，没有找到和" +
                        "<b style='color:red;'>" +
                        queryString +
                        "</b>" +
                        "相关的内容</span>"
                );
            }
            self.$refs.search_scrollbar.update();
            //self.$refs.searchPopover.updatePopper();
        },
        getFundInformation(symbolValue) {
            let self = this;
            let symbolInfo = "";
            if (
                symbolValue.indexOf("</span><span class='searchbox_title'>") >
                -1
            ) {
                symbolInfo = symbolValue.split(
                    "</span><span class='searchbox_title'>"
                );

                symbolValue = symbolInfo[0];
                symbolValue = symbolValue
                    .replace("<b style='color:red;'>", "")
                    .replace("<span class='searchbox_symbol'>", "")
                    .replace("</b>", "");
            }
            if (!isNaN(Number(symbolValue))) {
                let symbolName = symbolInfo[1]
                    .replace("</span>", "")
                    .replace("<b style='color:red;'>", "")
                    .replace("</b>", "");
                self.fundList[self.tableIndex].symbol = symbolValue;
                self.fundList[self.tableIndex].name = symbolName;
                self.fundList[self.tableIndex].symbolInfo =
                    symbolValue + " " + symbolName;
            }
            self.$refs["items_" + self.tableIndex].$refs.popper.hidden = true;
        },
        //读取客户导入的组合持仓数据
        importPortfolioHoldings(file, fileList) {
            this.readPortfolioHoldingsFromLocalFile(
                file,
                this.parseHoldingWorkbook
            );
        },
        readPortfolioHoldingsFromLocalFile(file, callback) {
            var reader = new FileReader();
            reader.onload = function (e) {
                var data = e.target.result;
                var workbook = XLSX.read(data, { type: "binary" });
                if (callback) callback(workbook);
            };
            reader.readAsBinaryString(file.raw);
        },
        parseHoldingWorkbook(workbook) {
            var sheetNames = workbook.SheetNames; // 工作表名称集合
            /*sheetNames.forEach(name => {
            var worksheet = workbook.Sheets[name]; // 只能通过工作表名称来获取指定工作表
            for(var key in worksheet) {
              // v是读取单元格的原始值
              console.log(key, key[0] === '!' ? worksheet[key] : worksheet[key].v);
            }
          });*/
            var worksheet = workbook.Sheets[sheetNames[0]]; // 这里我们只读取第一张sheet
            var jsonObj = XLSX.utils.sheet_to_json(worksheet);
            this.fundList = [];
            for (var i = 0; i < jsonObj.length; ++i) {
                var item = {};
                item["symbol"] = jsonObj[i]["基金代码"];
                item["weight"] = jsonObj[i]["权重(%)"].toFixed(5);
                
                this.fundList.push(item);
                this.getFundName(item["symbol"], i);
            }

            this.handleCalRatio();
        },
        progressFormat(percentage) {
            percentage = Math.round((percentage / 100) * 5 * 100) / 100;
            return percentage === 0 ? "" : `${percentage}`;
        },

        getNameFromSymbolInfo(symbolInfo) {
            var pos = symbolInfo.indexOf(" ");
            var name = "";
            if (pos > 0) {
                name =  symbolInfo.substring(pos+1,symbolInfo.length);
            }
            return name;
        },

        exportPortfolioHoldings() {
            var exportData = [["基金代码", "权重(%)", "基金名称"]];

            for (let i = 0; i < this.fundList.length; i++) {
                if (this.fundList[i].symbol) {
                    var row = [];
                    row.push(this.fundList[i].symbol);
                    row.push(this.fundList[i].weight);
                    if (this.fundList[i].symbolInfo) {
                        row.push(this.getNameFromSymbolInfo(this.fundList[i].symbolInfo));
                    }
                    exportData.push(row);
                }
            }

            var riskRow = [];
            riskRow[0] = "组合持仓风险";
            riskRow[1] = (
                (this.positionRiskScore_percentage * 5) /
                100
            ).toFixed(2);
            exportData.push(riskRow);
            riskRow = [];
            riskRow[0] = "评级调整风险";
            riskRow[1] = (
                (this.morningstarRiskLevel_percentage * 5) /
                100
            ).toFixed(2);
            exportData.push(riskRow);
            riskRow = [];
            riskRow[0] = "业绩波动风险";
            riskRow[1] = (
                (this.standardDeviationLevel_percentage * 5) /
                100
            ).toFixed(2);
            exportData.push(riskRow);
            riskRow = [];
            riskRow[0] = "下行波动风险";
            riskRow[1] = (
                (this.downsideDeviationLevel_percentage * 5) /
                100
            ).toFixed(2);
            exportData.push(riskRow);
            riskRow = [];
            riskRow[0] = "总体风险得分";
            riskRow[1] = ((this.totalRisk_percentage * 5) / 100).toFixed(2);
            exportData.push(riskRow);
            riskRow = [];
            riskRow[0] = "附加规模风险";
            riskRow[1] = (
                (this.additionalScaleScore_percentage * 5) /
                100
            ).toFixed(2);
            exportData.push(riskRow);
            riskRow = [];
            riskRow[0] = "风险等级结果";
            riskRow[1] = this.totalRisk;
            exportData.push(riskRow);

            var sheet = XLSX.utils.aoa_to_sheet(exportData);
            openDownloadDialog(
                sheet2blob(XLSX, sheet),
                "组合持仓与风险数据.xlsx"
            );
        },
        downloadTemplateFile() {
            var exportData = [
                ["基金代码", "权重(%)", "基金名称"],
                ["050022", 50, "博时回报混合"],
                ["070002", 50, "嘉实增长混合"],
            ];

            var sheet = XLSX.utils.aoa_to_sheet(exportData);
            openDownloadDialog(sheet2blob(XLSX, sheet), "组合持仓模板.xlsx");
        },
        nextStep() {
            let self = this;
            if (self.show1Div == true) {
                //先判断是否满足前往下一步的条件
                if (self.reportName == "") {
                    this.$message.error('请输入组合名称！');
                    return;
                }
                this.show1Div = !this.show1Div;
                this.show2Div = !this.show2Div;
                self.stepIndex = 1;
                self.nextStepText = '计算风险';
                self.marginLeft = 0;
                self.showForwardButton = true;
                self.showNextButton = true;
            } else if (self.show2Div == true) {
                let isRun = this.handleCalculation();
                if (!isRun) {
                    return;
                }
            }

        },
        forwardStep() {
            let self = this;
            if (self.show2Div == true) {
                this.show1Div = !this.show1Div;
                this.show2Div = !this.show2Div;
                self.stepIndex = 0;
                self.nextStepText = '输入持仓';
                self.marginLeft = '1150px';
                self.showForwardButton = false;
                self.showNextButton = true;
            } else if (self.show3Div == true){
                this.show2Div = !this.show2Div;
                this.show3Div = !this.show3Div;
                self.stepIndex = 1;
                self.marginLeft = 0;
                self.showForwardButton = true;
                self.showNextButton = true;
            }    
        }
    },
};
</script>
<style lang="scss">
@import "../../public/sass/components/portfolioRisk";
</style>
<style scoped>
/*调整checkBox的样式 begin*/
.el-checkbox_overwrite >>> .el-checkbox__inner {
    width: 24px !important;
    height: 24px !important;
}

.el-checkbox_overwrite >>> .el-checkbox__input .el-checkbox__inner::after {
    border: 2px solid #fff !important;

    box-sizing: content-box !important;
    content: "" !important;
    border-left: 0 !important;
    border-top: 0 !important;
    left: 5px !important;
    position: absolute !important;
    top: 1px !important;
    width: 8px !important;
    height: 12px !important;
    transform: rotate(45deg) scaleY(1) !important;
}
/*调整checkBox的样式 end*/

/*给table最后3列添加上左边的线 begin*/
.portfolioRiskTable >>> table tr th:nth-last-child(1) {
    border-right: 1px solid #ebeef5 !important;
}
.portfolioRiskTable >>> table tr:nth-child(1) th {
    border-top: 1px solid #ebeef5 !important;
    line-height: 48px;
}

.portfolioRiskTable >>> table tr:nth-child(4) {
    border-right: 1px solid red !important;
    line-height: 48px;
}

/*给table最后3列添加上左边的线 end*/

.left_floats{
    width: 13.5%;
    margin-right: 43px;
}
.left_floatss {
    width: 14.8%;
    margin-right: 93px;
}
.left_floatsss {
    width: 13.5%;
    margin-right: 93px;
}

/*给table最后3列添加上左边的线 end*/
/* #demo{
        background-color: #fff;
        width: 1000px;
        height: 5650px;
        margin: auto;
    } */
#demo2{
        background-color: #fff;
        width: 1000px;
        height: 2830px;
        margin: auto;
        position: absolute;
        top:1000px;
    }
#demo3{
        background-color: #fff;
        width: 1000px;
        height: 4245px;
        margin: auto;
    }
#demo4{
        background-color: #fff;
        width: 1000px;
        height: 5650px;
        margin: auto;
    }
.head-div {
        float: left;
        margin-top: 25px;
    }
    .head-left {
        margin-left: 97px;
        font-size: 12px;
    }
    .head-text {
        font-weight: 600;
    }
    .head-center {
        margin-left: 150px;
        font-size: 20px;
        font-weight: 200;
    }


	.head-div2 {
        float: left;
        margin-top: 110px;
		margin-left: 8px;
    }
    .head-left2 {
        margin-left: 85px;
        font-size: 12px;
    }
    .head-text2 {
        font-weight: 600;
    }
    .head-center2 {
        margin-left: 162px;
        font-size: 20px;
        font-weight: 200;
    }


	.head-div3 {
        float: left;
        margin-top: 110px;
		/* margin-left: -235px; */
    }
	.head-left3 {
        margin-left: 94px;
        font-size: 12px;
    }

    .head-banner {
        /* margin-top: 20px; */
    }
    /* .head-img {
        margin-top: 15px;
        width: 100%;
    } */
.imgs_logo {
    height: 110px;
    width: 100%;
    margin-top: 25px;
    /* margin-right: 15px; */
    float: right;
    /* margin-left: 60%; */
    background: url("../../public/images/banner3.png") no-repeat;
    }
    .line-class {
        float: right;
	    width: 56%;
	    height: 8px;
	    border-top: solid #0d0d0d 2px;
		margin-top: 45px;
		margin-right: 46px;
    }
    .line2-class{
        float: right;
	    width: 56%;
	    height: 8px;
	    border-top: solid #0d0d0d 2px;
		margin-top: 10px;
		margin-right: 46px;
    }

    .link-top1-area {
		margin-top: 35px;
		margin-left: 275px;
		font-weight: 600;
		font-size: 13px;
		/* .top1-input {
			// float: right;
			margin-left: 350rpx;
		} */
	}
    .top1-title {
        float: left;
		margin-left: 119px;
    }
    .top1-input {
		float: left;
		margin-left: 205px;
	}
    .top2-input {
		float: left;
		margin-left: 179px;
	}
    .link-top3 {
		float: right;
	    width: 87%;
	    height: 1px;
	    border-top: solid #0d0d0d 2px;
		margin-top: 45px;
		margin-right: 45px;
	}
    .link-top5-area {
		margin-top: 25px;
		/* margin-left: 225px; */
		font-size: 13px;
	}
    .link-top5 {
	    width: 100%;
	    height: 1px;
        float: right;
	    border-top: solid #0d0d0d 2px;
		/* margin-top: 6px;
		margin-right: 5px; */
	}
	.link-top11 {
		float: right;
	    width: 87%;
	    height: 1px;
	    border-top: solid #0d0d0d 2px;
		margin-top: 60px;
		margin-right: 40px;
	}
    .top5-title {
		font-weight: 600;
		float: left;
		margin-left: 83px;
		margin-top: 5px;
	}
    .top5-input {
		float: left;
		width: 568px;
		height: 50px;
		/* padding-right: 27px; */
        margin-left: 203px;
		line-height: 20px;
		font-weight: 100;
        margin-top: 5px;
        letter-spacing:1px;
        text-align: left;
	}
	.top21-input {
		float: left;
		width: 568px;
		height: 50px;
        margin-left: 243px;
		line-height: 23px;
		font-weight: 100;
        margin-top: 5px;
        letter-spacing:1px;
        text-align: left;
	}
	.top28-input {
		float: left;
		width: 568px;
		height: 50px;
        margin-left: 227px;
		line-height: 23px;
		font-weight: 100;
        margin-top: 5px;
        letter-spacing:1px;
        text-align: left;
	}
	.top22-input {
		float: left;
		width: 568px;
		height: 50px;
		/* padding-right: 27px; */
        margin-left: 359px;
		line-height: 23px;
		font-weight: 100;
        margin-top: 65px;
        letter-spacing:1px;
        text-align: left;
	}
	.top23-input {
		float: left;
		width: 568px;
		height: 50px;
		/* padding-right: 27px; */
        margin-left: 359px;
		line-height: 23px;
		font-weight: 100;
        margin-top: 30px;
        letter-spacing:1px;
        text-align: left;
	}
	.top33-input {
		float: left;
		width: 568px;
		height: 50px;
        margin-left: 228px;
		line-height: 23px;
		font-weight: 100;
        margin-top: 5px;
        letter-spacing:1px;
        text-align: left;
	}
	.top34-input {
		float: left;
		width: 568px;
		height: 50px;
        margin-left: 228px;
		line-height: 23px;
		font-weight: 100;
        margin-top: 5px;
        letter-spacing:1px;
        text-align: left;
	}
    .top6-div {
		width: 100%;
		float: left;
		display: flex;
		margin-top: 5px;
		margin-left: 355px;
		display: inline-block;
    }
	.div1 {
		text-align: center;
		height: 30px;
		border:1px solid #000000;
		float: left;
		box-sizing: border-box;
		width: 12%;
		background-color: #ffffff;
		border-top: none;
	}
    .top7-div {
        float: left;
        margin-left: 310px;
    }
    .div2 {
		float: left;
		margin-left: 90px;
		/* margin-right: 32px; */
		margin-top: 5px;
		size: 5px;
		background: transparent;
		border: 15px solid;
		border-top: transparent;
		border-left-color: transparent;
		border-right-color: transparent;
		border-bottom-color: #020202;
	}

        .top7-title {
		    font-weight: 600;
			float: left;
			margin-left: 83px;
			margin-top: 5px;
			font-size: 14px;
		}
        .top7-input {
			font-size: 13px;
			float: left;
			/* width: 451px; */
			margin-top: 52px;
			padding-right: 477px;
			line-height: 20px;
			font-weight: 100;
		}
		.top8-input {
			font-size: 13px;
			float: left;
			/* width: 451px; */
			margin-top: 20px;
			padding-right: 477px;
			line-height: 20px;
			font-weight: 100;
		}
        .top9-input {
			font-size: 13px;
			float: left;
			margin-top: 20px;
			line-height: 20px;
			font-weight: 100;
			margin-left: 5px;
		}
		.top10-input {
			font-size: 13px;
			float: left;
			margin-left: 356px;
			margin-top: 20px;
			line-height: 20px;
			font-weight: 600;
		}
		.top11-input {
			font-size: 13px;
			float: right;
			margin-top: 20px;
			line-height: 20px;
			font-weight: 600;
			margin-right: 152px;
		}
		.top12-input {
			font-size: 13px;
			float: right;
			margin-top: 20px;
			line-height: 20px;
			font-weight: 100;
			margin-right: -174px;
		}
		.top13-input {
			font-size: 13px;
			float: right;
			margin-top: 20px;
			line-height: 20px;
			font-weight: 600;
			margin-right: 218px;
		}
		.top14-input {
			font-size: 13px;
			float: right;
			margin-top: 20px;
			line-height: 20px;
			font-weight: 100;
			margin-right: -108px;
		}
		.top15-input {
			font-size: 10px;
			float: left;
			margin-left: 357px;
			margin-top: 20px;
			font-weight: 100;
		}
		.top16-input {
			font-size: 13px;
			float: left;
			margin-left: 362px;
			margin-top: 20px;
			line-height: 20px;
			font-weight: 100;
		}
		.top17-input {
			font-size: 13px;
			float: left;
			margin-top: 20px;
			line-height: 20px;
			font-weight: 100;
			margin-left: 5px;
		}
		.top18-input {
			font-size: 13px;
			float: left;
			margin-left: 362px;
			margin-top: 2px;
			line-height: 20px;
			font-weight: 100;
		}
		.top19-input {
			font-size: 13px;
			float: left;
			margin-top: 2px;
			line-height: 20px;
			font-weight: 100;
			margin-left: 5px;
		}
		.top31-input {
			font-size: 13px;
			float: left;
			margin-left: 360px;
			margin-top: 45px;
			line-height: 20px;
			font-weight: 600;
		}
		.top32-input {
			font-size: 13px;
			float: left;
			margin-top: 45px;
			line-height: 20px;
			font-weight: 100;
			margin-left: 2px;
		}
		.top30-title {
			font-weight: 600;
			float: left;
			margin-left: 90px;
			margin-top: 5px;
		}
        .top7-comeup{
            float: right;
        }
        .containers {
			float: right;
			margin-right: 50px;
			width: 74%;
			margin-top: -16px;
			background-color: #ddd;
			border-radius: 5px;
        }
        .skills1 {
				border-radius: 5px;
				font-size: 10px;
				text-align: right;
				padding-right: 20px;
				color: white;
				width: 60%; 
				background-color: #e9a36d;
			}
            .skills2 {
				border-radius: 5px;
				font-size: 10px;
				text-align: right;
				padding-right: 20px;
				color: white;
				width: 40%; 
				background-color: #e9a36d;
			}
			.skills3 {
				border-radius: 5px;
				font-size: 10px;
				text-align: right;
				padding-right: 20px;
				color: white;
				width: 40%; 
				background-color: #e9a36d;
			}
			.skills4 {
				border-radius: 5px;
				font-size: 10px;
				text-align: right;
				padding-right: 20px;
				color: white;
				width: 40%; 
				background-color: #e9a36d;
			}
			.skills5 {
				border-radius: 5px;
				font-size: 12px;
				text-align: right;
				padding-right: 20px;
				color: white;
				width: 60%; 
				background-color: #e9a36d;
			}
            .skills6 {
				border-radius: 5px;
				font-size: 10px;
				text-align: right;
				padding-right: 20px;
				color: white;
				width: 40%; 
				background-color: #e9a36d;
			}
            .link-top4 {
		        float: right;
	            width: 87%;
	            height: 1px;
	            border-top: solid #0d0d0d 2px;
		        margin-top: 8px;
		        margin-right: 40px;
	        }
        .containers1 {
		    float: right;
		    margin-right: 40px;
		    /* width: 67%; */
		    margin-top: 40px;
		    background-color: #ddd;
		    height: 25px;
		}
        .skills7 {
			float: left;
			font-size: 11px;
			/* text-align: right; */
			margin-left: -36px;
			padding-right: 111px;
            line-height: 2.5;
			color: white;
			color: #060606;
			font-weight: 600;
		}
		.skills8 {
			font-size: 11px;
			text-align: right;
			padding-right: 35px;
			color: white;
			color: #060606;
			font-weight: 600;
			line-height: 2.5;
		}
		.skills9 {
			font-size: 11px;
			text-align: right;
			color: white;
			color: #060606;
			font-weight: 600;
		}
		.skills10 {
			float: left;
			margin-left: 7px;
			font-size: 11px;
			/* text-align: right; */
			padding-right: 80px;
            line-height: 2.5;
			color: white;
			color: #060606;
			font-weight: 600;
		}
        .top8-title {
		    font-weight: 600;
			float: left;
			margin-left: 89px;
			margin-top: 5px;
			font-size: 14px;
		}

        .containers2 {
			float: right;
			margin-right: 40px;
			width: 59%;
			margin-top: 5px;
			height: 25px;
			}
            .skills11 {
                float: left;
				font-size: 10px;
				text-align: left;
				color: white;
				color: #060606;
				font-weight: 100;
                margin-left: 40px;
                margin-top: 6px;
			}
			.skills12 {
				font-size: 10px;
				text-align: left;
				color: white;
				color: #060606;
				font-weight: 100;
				float: right;
				margin-right: 304px;
				/* position:absolute; */
				/* left: 875px; */
				line-height: 25px;
			}
			.skills13 {
				font-size: 10px;
				text-align: left;
				color: white;
				color: #060606;
				font-weight: 100;
				float: right;
				margin-right: -135px;
				/* position:absolute;
				left: 970px; */
				line-height: 25px;
            }
			.skills14 {
				font-size: 10px;
				text-align: right;
				color: white;
				color: #060606;
				font-weight: 100;
				float: right;
				margin-right: -221px;
				/* position:absolute;
				left: 1085px; */
				line-height: 25px;
			}
			.skills15 {
				font-size: 10px;
				text-align: right;
				color: white;
				color: #060606;
				font-weight: 100;
				float: right;
				margin-right: -315px;
				/* position:absolute;
				left: 1190px; */
				line-height: 25px;
			}
			.skills16 {
                float: left;
				font-size: 10px;
				text-align: left;
				color: white;
				color: #060606;
				font-weight: 100;
                margin-left: 11px;
                margin-top: 6px;
			}
            .img-star {
					/* width: 100%;
                    height: 110px;
					margin-top: 7px;
					float: right;
                    background: url("../../public/images/star.png") no-repeat; */
                    height: 10px;
                    width: 75%;
                    margin-top: 8px;
                    float: right;
                    margin-right: 21px;
                    background: url("../../public/images/star.png") no-repeat;
			}
            .img-star2 {
                    height: 10px;
                    width: 80%;
                    margin-top: -10px;
                    float: right;
					margin-right: 9px;
                    /* margin-left: 3px; */
                    background: url("../../public/images/star.png") no-repeat;
            }
            .img-star3 {
                    height: 10px;
                    width: 80%;
                    margin-top: -10px;
                    float: right;
                    margin-right: -2px;
                    /* margin-left: 3px; */
                    background: url("../../public/images/star.png") no-repeat;
            }
            .img-star4 {
                    height: 10px;
                    width: 80%;
                    margin-top: -10px;
                    float: right;
                    margin-right: -12px;
                    /* margin-left: 3px; */
                    background: url("../../public/images/star.png") no-repeat;
            }
            .img-star5 {
                    height: 10px;
                    width: 80%;
                    margin-top: -10px;
                    float: right;
                    margin-right: -23px;
                    /* margin-left: 3px; */
                    background: url("../../public/images/star.png") no-repeat;
            }
            .link-top6 {
		        float: right;
		        width: 95%;
		        height: 1px;
		        border-top: solid #0d0d0d 2px;
		        margin-top: 65px;
		        margin-right: -46px;
	        }
			.link-top9 {
		        float: right;
		        width: 96%;
		        height: 1px;
		        border-top: solid #0d0d0d 2px;
		        margin-top: 160px;
		        margin-right: -56px;
	        }
			.link-top10 {
		        float: right;
		        width: 96%;
		        height: 1px;
		        border-top: solid #0d0d0d 2px;
		        margin-top: 710px;
		        margin-right: -56px;
	        }
            .img-mslogo {
			    width: 17%;
                height: 55px;
                float: left;
			    margin-left: 93px;
                margin-top: 8px;
                background: url("../../public/images/ms_logo.png") no-repeat;
		    }
            .bottom-area {
			    float: right;
			    width: 540px;
			    height: 50px;
                /* margin-right: 20px; */
			    /* padding-right: 43px; */
                margin-top: 7px;
			    line-height: 20px;
			    font-weight: 100;
			    font-size: 10px;
                text-align: left;
		    }

			.control-div {
				position: absolute;
				top: 2650px;
				width: 66%;
			}
			.control-div2 {
				position: absolute;
				top: 2827px;
				width: 80%;
			}
			.control-div3 {
				position: absolute;
				/* display: none; */
				top: 3480px;
				width: 66%;
			}
			.control-div4 {
				position: absolute;
				top: 1350px;
				width: 68%;
			}
			.control-div5 {
				position: absolute;
				top: 1440px;
				width: 80%;
			}
			.control-div6 {
				position: absolute;
				top: 4220px;
				width: 80%;
			}
			.control-div7 {
				position: absolute;
				top: 4950px;
				width: 66%;
			}
			.hiddenOrshow-div {
				position: absolute;
				top: 1655px;
				width: 66%;
			}
			.hiddenOrshow-div2 {
				position: absolute;
				top: 2350px;
				width: 66%;
			}
			.hiddenOrshow-div7 {
				position: absolute;
				top: 3765px;
				width: 66%;
			}
			.hiddenOrshow-div10 {
				position: absolute;
				top: 5210px;
				width: 73%;
			}
			.hiddenOrshow-div13 {
				position: absolute;
				top: 3055px;
				width: 66%;
			}
			.hiddenOrshow-div16 {
				position: absolute;
				top: 4466px;
				width: 66%;
			}









            .head-content {
                margin: 0 auto;
                padding-top: 20px;
                padding-bottom: 20px;
                overflow: hidden;
            }
            .head-date {
                float: left;
                margin-left: 93px;
                font-weight: 600;
                line-height: 2;
            }
            .head-title {
                float: left;
                margin-left: 175px;
                font-size: 17px;
            }
            .logo-img {
                width: 100%;
                height: 113px;
                background: url("../../public/images/banner3.png") no-repeat;
            }
            .des-div {
                width: 100%;
                height: 225px;
            }
            .des-msg {
                width: 52.6%;
                height: 175px;
                float: right;
                margin-right: 75px;
                margin-top: 45px;
                border: 1px solid #050505;
                border-left: none;
                border-right: none;
                border-bottom: none;
            }
            .desc { 
                height: 35px;
                width: 100%;
                border-bottom: 1px solid #050505;
                line-height: 35px;
                margin: 0 auto;
            }
            .desc-title {
                float: left;
                clear: both;
                font-weight: 600;
            }
            .desc-content {
                float: left;
                padding-left: 155px;
            }
            .desc-content2 {
                float: left;
                padding-left: 132px;
            }
            .desc:nth-child(4) {
                border-bottom: none;
            }
            .comeupRisk-desc {   
                margin: 0 auto;
                width: 85%;
                height: 95px;
                /* background-color: #b9b9bb; */
                border: 1px solid;
                border-bottom: none;
                border-left: none;
                border-right: none;
            }
            .comeupRisk-div1 {   
                width: 38%;
                height: 100%;
                float: left;
                display: inline-block;
                /* background-color: #929294; */
            }
            .bottomlogo-div {
                width: 25.5%;
                height: 100%;
                float: left;
                display: inline-block;
            }
            .bottomtext-div {
                width: 74.5%;
                height: 100%;
                float: left;
                display: inline-block;
            }
            .comeupRisk-div2{
                float: right;
                width: 62%;
                height: 100%;
                /* background-color: #afafb1; */
                /* height: 100%; */
                /* text-align: left; */
                /* margin-top: 5px;
                line-height: 2; */
            }
            .comeupRisk-area{
                float: left;
                width: 100%;
                /* background-color: #afafb1; */
                /* height: 100%; */
                text-align: left;
                margin-top: 5px;
                line-height: 2;
            }
            .comeupRisk-title {    
                float: left;
                font-size: 13px;
                font-weight: 600;
                margin-top: 7px;
            }
            .comeupRisk-text{
                margin-top: 5px;
            }

            .evalRisk-title {    
                float: left;
                font-size: 13px;
                font-weight: 600;
                margin-top: 7px;
            }
            .evalRisk-div2{
                float: left;
                width: 100%;
                /* background-color: #afafb1; */
                height: 85%;
                text-align: left;
                margin-top: 12px;
                line-height: 2;
            }
            .levelArea-div {
                width: 100%;
                height: 40px;
                border: 1px solid;
                border-top: none;
                /* background-color: #bbbbd8; */
            }
            .area11 {
                float: left;
                width: 19.8%;
                height: 38px;
                border-top: none;
                /* border: 0.1px solid; */
                /* border-left: 1px solid black; */
                text-align: center;
                margin-top: 2px;
                font-size: 13px;
                position: relative;
            }
            .area12 {
                float: left;
                width: 19.8%;
                height: 38px;
                border-top: none;
                /* border: 0.1px solid; */
                border-left: 1px solid black;
                text-align: center;
                margin-top: 2px;
                font-size: 13px;
                position: relative;
            }
            .area13 {
                float: left;
                width: 19.8%;
                height: 38px;
                border-top: none;
                /* border: 0.1px solid; */
                border-left: 1px solid black;
                text-align: center;
                margin-top: 2px;
                font-size: 13px;
                position: relative;
            }
            .area14 {
                float: left;
                width: 19.8%;
                height: 38px;
                border-top: none;
                /* border: 0.1px solid; */
                border-left: 1px solid black;
                text-align: center;
                margin-top: 2px;
                font-size: 13px;
                position: relative;
            }
            .area15 {
                float: left;
                width: 19.8%;
                height: 38px;
                border-top: none;
                /* border: 0.1px solid; */
                border-left: 1px solid black;
                text-align: center;
                margin-top: 2px;
                font-size: 13px;
                position: relative;
            }
            .area16 {
                float: left;
                width: 19.8%;
                height: 38px;
                border-top: none;
                /* border: 0.1px solid; */
                border-left: 1px solid black;
                text-align: center;
                margin-top: 2px;
                font-size: 13px;
                position: relative;
            }
            .levelArea-div2 {
                width: 100%;
                height: 40px;
                /* border: 1px solid; */
                border-top: none;
            }
            .area2 {
                float: left;
                width: 20%;
                height: 39px;
                text-align: center;
                margin-top: 2px;
                font-size: 13px;
                margin-left: 38px;
                margin-right: 39px;
            }
            .area3 {
                float: left;
                width: 20%;
                height: 39px;
                text-align: center;
                margin-top: 2px;
                font-size: 13px;
                margin-left: 38px;
                margin-right: 39px;
            }
            .area4 {
                float: left;
                width: 20%;
                height: 39px;
                text-align: center;
                margin-top: 2px;
                font-size: 13px;
                margin-left: 38px;
                margin-right: 39px;
            }
            .area5 {
                float: left;
                width: 20%;
                height: 39px;
                text-align: center;
                margin-top: 2px;
                font-size: 13px;
                margin-left: 38px;
                margin-right: 39px;
            }
            .area6 {
                float: left;
                width: 20%;
                height: 39px;
                text-align: center;
                margin-top: 2px;
                font-size: 13px;
                margin-left: 38px;
                margin-right: 39px;
            }
            .area2-div {
                width: 20%;
                height: 40px;
                float: left;
            }

            .zixiang-div1 {
                width: 38%;
                height: 425px;
                float: left;
                display: inline-block;
            }
            .zixiang-div2 {
                width: 62%;
                height: 425px;
                float: right;
                /* background-color: beige; */
                position: relative;
            }
            .zixiang-div3 {
                width: 97%;
                height: 260px;
                /* background-color: blanchedalmond; */
                position: absolute;
                margin-top: 30px;
            }
            .zixiang-desc {
                margin: 0 auto;
                width: 85%;
                height: 425px;
                border: 1px solid;
                border-bottom: none;
                border-left: none;
                border-right: none;
            }
            .zixiang-div4 {
                width: 100%;
                height: 75px;
                /* background-color: bisque; */
                position: absolute;
                bottom: 0;
                margin-bottom: 64px;
            }
            .zixiang-div5 {
                width: 100%;
                height: 30px;
                /* background-color: burlywood; */
                position: absolute;
                bottom: 0;
                font-size: 11px;
                text-align: left;
                line-height: 3;
            }
            .item-div {
                width: 100%;
                height: 43.3px;
                /* background-color: cadetblue; */
                /* border: 1px solid; */
            }

            .item-text {
                letter-spacing: 0.5px;
                margin-top: 15px;
                float: left;
            }
            .item-compass {
                width: 377px;
                height: 43px;
                right: 0;
                position: absolute;
                /* background-color: blueviolet; */
            }
            .containers10 {
                margin-top: 17px;
                width: 100%;
                background-color: #ddd;
                border-radius: 5px;
                float: right;
            }
            .skills20 {
                border-radius: 5px;
                font-size: 10px;
                text-align: right;
                padding-right: 20px;
                color: white;
                width: 60%;
                background-color: #e9a36d;
            }
            .skills21 {
                border-radius: 5px;
                font-size: 10px;
                text-align: right;
                padding-right: 20px;
                color: white;
                width: 40%;
                background-color: #e9a36d;
            }
            .skills22 {
				border-radius: 5px;
				font-size: 10px;
				text-align: right;
				padding-right: 20px;
				color: white;
				width: 40%; 
				background-color: #e9a36d;
			}
			.skills23 {
				border-radius: 5px;
				font-size: 10px;
				text-align: right;
				padding-right: 20px;
				color: white;
				width: 40%; 
				background-color: #e9a36d;
			}
			.skills24 {
				border-radius: 5px;
				font-size: 12px;
				text-align: right;
				padding-right: 20px;
				color: white;
				width: 60%; 
				background-color: #e9a36d;
			}
            .skills25 {
				border-radius: 5px;
				font-size: 10px;
				text-align: right;
				padding-right: 20px;
				color: white;
				width: 0%; 
				/* background-color: #e9a36d; */
			}
            .pingheng-div {
                width: 50%;
                height: 40px;
                /* background-color: beige; */
                float: left;
                text-align: left;
                line-height: 4;
            }
            .yeji-div {
                width: 50%;
                height: 40px;
                /* background-color: azure; */
                float: left;
            }
            .fengxian-div {
                width: 50%;
                height: 35px;
                /* background-color: beige; */
                float: left;
                text-align: left;
                line-height: 3;
            }

            .zuhe-desc {
                margin: 0 auto;
                width: 85%;
                height: 300px;
                border: 1px solid;
                border-bottom: none;
                border-left: none;
                border-right: none;
            }
            .zuhe-desc2 {
                margin: 0 auto;
                width: 85%;
                height: 300px;
                border: 1px solid;
                border-bottom: none;
                border-left: none;
                border-right: none;
                margin-top: 30px;
            }
            .zuhe-desc3 {
                margin: 0 auto;
                width: 85%;
                height: 300px;
                border: 1px solid;
                border-bottom: none;
                border-left: none;
                border-right: none;
                margin-top: 30px;
            }
            .zuhe-div1 {
                width: 25%;
                height: 300px;
                float: left;
                display: inline-block;
            }
            .zuhe-div2 {
                width: 75%;
                height: 300px;
                float: right;
                position: relative;
            }
            .msg-div {
                width: 100%;
                height: 220px;
                position: absolute;
                margin-top: 35px;
            }
            .msg-head {
                width: 100%;
                height: 35px;
                background-color: rgb(235 235 235);
            }
            .head1 {
                width: 9%;
                height: 35px;
                float: left;
                line-height: 3;
                /* text-align: left; */
                font-weight: 600;
            }
            .head2 {
                width: 35%;
                height: 35px;
                float: left;
                line-height: 3;
                font-weight: 600;
            }
            .head3 {
                width: 21%;
                height: 35px;
                float: left;
                line-height: 3;
                font-weight: 600;
            }
            .head4 {
                width: 14%;
                height: 35px;
                float: left;
                line-height: 3;
                font-weight: 600;
            }
            .head5 {
                width: 9%;
                height: 35px;
                float: left;
                line-height: 3;
                font-weight: 600;
            }
            .head6 {
                width: 12%;
                height: 35px;
                float: left;
                line-height: 3;
                /* text-align: right; */
                font-weight: 600;
            }
            .msg-content {
                width: 100%;
                height: 35px;
                border-bottom: 1px solid;
            }

            .msg-star {
                width: 84%;
                height: 9px;
                /* background-color: bisque; */
                margin-top: 14.5px;
                margin-left: 15px;

            }
            .star {
                float: left;
                width: 17%;
                height: 100%;
                background: url("../../public/images/star.png") no-repeat;
            }

            .bottomText-area{
                float: left;
                width: 100%;
                /* background-color: #afafb1; */
                /* height: 100%; */
                text-align: left;
                margin-top: 5px;
                line-height: 2;
                font-size: 9px;
            }
            .ms-newlogo {
                width: 100%;
                height: 100%;
                margin-top: 7px;
                background: url("../../public/images/ms_logo.png") no-repeat;
            }
            .msDate-area {
                width: 32%;
                height: 50px;
                position: absolute;
                bottom: 0;
                margin-bottom: 20px;
            }
            .msDate-area2 {
                width: 32%;
                height: 50px;
                position: absolute;
                top: 0;
                margin-top: 730px;
            }
            .msDate-area3 {
                width: 32%;
                height: 50px;
                position: absolute;
                top: 0;
                margin-top: 2720px;
                margin-left: 170px;
            }
            .msDate-area4 {
                width: 32%;
                height: 50px;
                /* position: absolute; */
                top: 0;
                margin-top: 435px;
                margin-left: 231px;
            }
            .msDate-area5 {
                width: 32%;
                height: 50px;
                position: absolute;
                top: 0;
                margin-top: 4130px;
                margin-left: 170px;
            }
            .msDate-area6 {
                width: 32%;
                height: 50px;
                /* position: absolute; */
                top: 0;
                margin-top: 435px;
                margin-left: 231px;
            }
            .msDate-area9 {
                width: 32%;
                height: 50px;
                /* position: absolute; */
                top: 0;
                margin-top: 430px;
                margin-left: 231px;
            }
            .msDate-div {
                width: 100%;
                height: 20px;
            }
            .note-desc {   
                margin: 0 auto;
                width: 85%;
                height: 95px;
                /* background-color: #b9b9bb; */
                border: 1px solid;
                border-bottom: none;
                border-left: none;
                border-right: none;
                margin-top: 35px;
            }
            .note-desc2 {   
                margin: 0 auto;
                width: 85%;
                height: 95px;
                /* background-color: #b9b9bb; */
                border: 1px solid;
                border-bottom: none;
                border-left: none;
                border-right: none;
                margin-top: 520px;
            }
            .note-desc3 {   
                margin: 0 auto;
                width: 85%;
                height: 95px;
                /* background-color: #b9b9bb; */
                border: 1px solid;
                border-bottom: none;
                border-left: none;
                border-right: none;
                margin-top: 35px;
            }
            .note-desc4 {   
                margin: 0 auto;
                width: 85%;
                height: 95px;
                /* background-color: #b9b9bb; */
                border: 1px solid;
                border-bottom: none;
                border-left: none;
                border-right: none;
                /* margin-top: 840px; */
                margin-top: 20px;
            }
            .note-desc6 {   
                margin: 0 auto;
                width: 85%;
                height: 95px;
                /* background-color: #b9b9bb; */
                border: 1px solid;
                border-bottom: none;
                border-left: none;
                border-right: none;
                /* margin-top: 840px; */
                margin-top: 30px;
            }
            .note-desc9 {   
                margin: 0 auto;
                width: 85%;
                height: 95px;
                /* background-color: #b9b9bb; */
                border: 1px solid;
                border-bottom: none;
                border-left: none;
                border-right: none;
                /* margin-top: 840px; */
                margin-top: 30px;
            }
            .note-title {
                width: 25.5%;
                height: 280px;
                float: left;
                display: inline-block;
            }
            .note-text {
                width: 74.5%;
                height: 280px;
                float: left;
                display: inline-block;
            }
            .noteText-area{
                float: left;
                width: 100%;
                text-align: left;
                margin-top: 5px;
                line-height: 2;
                font-size: 12px;
            }
            .noteText-div2 {
                margin-top: 20px;
            }
            .comeupRisk-desc2 {   
                margin: 0 auto;
                width: 85%;
                height: 95px;
                margin-top: 1010px;
                /* background-color: #b9b9bb; */
                border: 1px solid;
                border-bottom: none;
                border-left: none;
                border-right: none;
            }
            .comeupRisk-desc3 {   
                margin: 0 auto;
                width: 85%;
                height: 95px;
                margin-top: 200px;
                /* background-color: #b9b9bb; */
                border: 1px solid;
                border-bottom: none;
                border-left: none;
                border-right: none;
            }
            .comeupRisk-desc4 {   
                margin: 0 auto;
                width: 85%;
                height: 95px;
                margin-top: 810px;
                /* background-color: #b9b9bb; */
                border: 1px solid;
                border-bottom: none;
                border-left: none;
                border-right: none;
            }
            .comeupRisk-desc5 {   
                margin: 0 auto;
                width: 85%;
                height: 95px;
                margin-top: 200px;
                /* background-color: #b9b9bb; */
                border: 1px solid;
                border-bottom: none;
                border-left: none;
                border-right: none;
            }
            .comeupRisk-desc6 {   
                margin: 0 auto;
                width: 85%;
                height: 95px;
                margin-top: 810px;
                /* background-color: #b9b9bb; */
                border: 1px solid;
                border-bottom: none;
                border-left: none;
                border-right: none;
            }
            .comeupRisk-desc7 {   
                margin: 0 auto;
                width: 85%;
                height: 95px;
                margin-top: 1000px;
                /* background-color: #b9b9bb; */
                border: 1px solid;
                border-bottom: none;
                border-left: none;
                border-right: none;
            }
            .comeupRisk-desc8 {   
                margin: 0 auto;
                width: 85%;
                height: 95px;
                margin-top: 1000px;
                /* background-color: #b9b9bb; */
                border: 1px solid;
                border-bottom: none;
                border-left: none;
                border-right: none;
            }
            .comeupRisk-desc9 {   
                margin: 0 auto;
                width: 85%;
                height: 95px;
                margin-top: 200px;
                /* background-color: #b9b9bb; */
                border: 1px solid;
                border-bottom: none;
                border-left: none;
                border-right: none;
            }
            .area-background {
                width: 100%;
                height: 38px;
                background-color: #ececec;
                position: absolute;
                top: 0;
            }

            .progress-bar2 {
                width: 104%;
            }

            /* #rightaa {
        width: 150px;
        height: 150px;
        margin: 100px auto;
        border-radius: 50%;
        border: 5px solid #0077CF;
        background-color: #0077CF;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      #rightaa::before {
        content: "";
        display: block;
        width: 88px;
        height: 50px;
        border: 20px solid #ffffff;
        border-right: none;
        border-top: none;
        transform: rotate(-45deg) translate(7px, -10px);
      } */
      .el-tabs__content >>> .el-row{
        height: 600px;
      }
      .area-body1 {
        width: 100%;
        height: 600px;
        background-color: rgba(216, 216, 216, 0.1);
      }
      .area-body2 {
        width: 100%;
        height: 1200px;
        background-color: rgba(216, 216, 216, 0.1);
      }
      .area-body3 {
        width: 100%;
        height: 2300px;
        background-color: rgba(216, 216, 216, 0.1);
      }
      .area-top {
          width: 100%;
          height: 85px;
          margin-top: -25px;
          background-color: #ffffff;
      }
      .area-main {
          width: 100%;
          height: 440px;
          /* background-color: #faef8e; */
      }
      .area-steps {
          width: 70%;
          margin: 0 auto;
          height: 85px;
          /* background-color: #ff764d; */
      }
      .area-step {
          width: 45%;
          margin: 0 auto;
          height: 85px;
          /* background-color: #ffffff; */
      }
      .area-content {
          display: block;
          width: 70%;
          margin: 0 auto;
          height: 440px;
          /* background-color: #8b807c; */
      }
      .content-title {
          display: flex;
          width: 100%;
          height: 75px;
          /* background-color: #99ffbb; */
          border-bottom: 1px solid #CCCCCC;
      }
      .title-text {
          font-size: 20px;
          font-weight: 600;
          align-self: center;
      }
      .content-main {
          width: 100%;
          height: 320px;
          /* background-color: #b0e7f8; */
      }

      .step-top1 {
          width: 100%;
          margin: 0 auto;
          height: 25px;
          /* background-color: #ffc2ac; */
      }
      .step-top2 {
          display: flex;
          width: 100%;
          margin: 0 auto;
          height: 25px;
          /* background-color: #edfcb8; */
          justify-content: center;
          align-items: self-end;
      }
      .step-text {
          /* background-color: #e9a36d; */
          flex: 1;
          font-size: 14px;
      }
      .step-top3 {
          display: flex;
          width: 100%;
          margin: 0 auto;
          height: 35px;
          /* background-color: #866a5f; */
      }
      .step-space {
          width: 100%;
          height: 100%;
          flex: 1.4;
      }
      .step-img1 {
          width: 100%;
          height: 100%;
          flex: 0.5;
          margin-top: 3px;
          justify-content: center;
          background: url("../../public/images/notyet.png") no-repeat;
      }
      .step-img2 {
          width: 100%;
          height: 100%;
          flex: 0.5;
          margin-top: 3px;
          justify-content: center;
          background: url("../../public/images/isok.png") no-repeat;
      }
      .step-img3 {
          width: 10px;
          height: 10px;
          /* flex: 0.5; */
          margin-top: 7px;
          justify-content: center;
          background-color: #CCCCCC;
          border-radius: 50%;
      }
      .step-line1 {
          width: 100%;
          height: 3px;
          flex: 3;
          margin-top: 11px;
          background-color: #CCCCCC;
      }
      .step-line2 {
          width: 100%;
          height: 3px;
          flex: 3;
          margin-top: 11px;
          background-color: #0077CF;
      }

      .zuhe-title {
          display: flex;
          width: 100%;
          height: 40px;
          /* background-color: aqua; */
      }
      .zuhe-name {
          font-size: 15px;
          font-weight: 600;
          align-self: flex-end;
      }
      .zuhe-input {
          width: 100%;
          height: 40px;
          /* background-color: rgb(103, 137, 248); */
      }
      .el-input >>> .el-input__inner {
          background-color: hsl(0deg 0% 88%);
          border-bottom: 2px solid #a7a7a7;
          height: 32px;
          margin-top: 4px;
      } 
      .touma-title {
          display: flex;
          width: 100%;
          height: 35px;
          /* background-color: rgb(236, 226, 77); */
      }
      .touma-name {
          flex: 0.8;
          text-align: -webkit-left;
          align-self: flex-end;
          font-size: 15px;
          font-weight: 600;
      }
      .touma-input {
          display: flex;
          width: 100%;
          height: 40px;
          /* background-color: rgb(243, 85, 235); */
      }
      .touma-value {
          flex: 0.8;
      }
      .touma-value2 {
          flex: 1;
          width: 100%;
          display: flex;
          justify-content: flex-start;
      }
      .touma-value3 {
          flex: 1;
          width: 100%;
          display: flex;
          justify-content: flex-end;
      }
      .el-select {
          width: 95.5%;
      }
      .el-date-editor.el-input, .el-date-editor.el-input__inner {
          width: 95.5%;
      }
      .touma-space {
          flex: 0.08;
      }
      .risklevel-name {
          flex: 0.8;
          text-align: -webkit-left;
          align-self: flex-end;
          font-size: 14px;
          font-weight: 350;
      }
      .risklevel-space {
          flex: 0.08;
      }
      .timerebalance-title {
          display: flex;
          width: 100%;
          height: 35px;
          /* background-color: rgb(255, 160, 71); */
      }
      .timerebalance-input {
          display: flex;
          width: 100%;
          height: 40px;
          /* background-color: rgb(144, 250, 74); */
      }
      .el-input--prefix >>> .el-input__inner {
          width: 100%;
      }
      .el-date-picker >>> .el-picker-panel__content {
          width: 240px;
      }
      .risklevel-title {
          display: flex;
          width: 100%;
          height: 40px;
          /* background-color: rgb(17, 231, 185); */
      }
      .el-checkbox_overwrite1 >>> .el-checkbox__inner {
          width: 19px;
          height: 19px;
      }
      .el-checkbox_overwrite2 >>> .el-checkbox__inner {
          width: 20px;
          height: 20px;
      }
      .lasterrisk-title {
          display: flex;
          width: 100%;
          height: 35px;
          /* background-color: rgb(6, 54, 54); */
      }
      .lasterrisk-name {
          font-size: 14px;
          font-weight: 350;
          align-self: flex-end;
      }
      .rebalanceFrequency_input {
          width: 95.5%;
      }
      .rebalanceFrequency_input >>> input {
          width: 100%;
          height: 33px;
          margin-top: 4px;
          background-color: hsl(0deg 0% 88%);
          border-bottom: 2px solid #a7a7a7;
      }
      .el-select >>> .el-input >>> .el-select__caret {
          line-height: 2.5;
      }
      .select-class {
          height: 35px;
          margin-top: 3px;
      }
      .risk-input {
          display: flex;
          width: 100%;
          height: 30px;
          /* background-color: aqua; */
      }
      .lastRisk_input {
          width: 100%;
      }
      .lastRisk_input >>> input {
          width: 946px;
          height: 33px;
          margin-top: 4px;
          background-color: hsl(0deg 0% 88%);
          border-bottom: 2px solid #a7a7a7;
      }
      .el-select >>> .el-input {
          display: flex;
      }
      .el-button--primary {
          background-color: #0077CF;
          margin-left: 1150px;
          margin-top: 7px;
      }
      .el-icon--right {
          margin-left: 5px;
          color: #ffffff;
      }
      .el-checkbox__input >>> .is-checked >>> .el-checkbox__inner::after {
          border: 0;
      }

      .funtion-area {
          display: flex;
          width: 100%;
          height: 65px;
      }
      .inout-div {
          flex: 1;
          width: 100%;
          height: 35px;
          align-self: flex-end;
      }
      .space-div {
          flex: 3;
          width: 100%;
          height: 35px;
          align-self: flex-end;
      }
      .inout2-div {
          flex: 1;
          width: 100%;
          height: 35px;
          align-self: flex-end;
          text-align: end;
      }
      .el-button--medium.is-round {
          height: 33px;
      }
      .el-button--text {
          color: #606266;
          text-decoration: underline;
      }
      .fundList-title {
          width: 100%;
          height: 245px;
      }
      .el-table >>> tr {
          height: 20px !important;
          background-color: #fcfcfc;
      }
      .el-table >>> .el-table__cell {
          padding: 0 0;
      }
      .div-right-border {
          border: 0;
      }
      .el-table >>> thead {
          color: #000000;
      }
      .el-table--enable-row-transition >>> .el-table__body >>> td.el-table__cell {
          background-color: #fcfcfc;
      }
      .is-leaf >>> .el-table__cell{
          border-bottom: 2px solid #a0a0a0 !important;
      }
      .fenpei-area {
          display: flex;
          width: 100%;
          height: 60px;
          /* background-color: rgb(17, 231, 185); */
      }
      .fenpei-div1 {
          flex: 1;
          width: 100%;
          text-align: justify;
          align-self: flex-end;
      }
      .fenpei-div2 {
          flex: 1;
          width: 100%;
          margin-top: 10px;
          text-align: justify;
      }
      .fenpei-space1 {
          flex: 3;
      }
      .fenpei-space2 {
          flex: 1;
      }
      .fenpei-text {
          color: red;
      }
      .el-button--info {
          background-color: #6b6b6b;
          height: 37px;
      }
      .row-class1 {
          height: 600px;
      }
      .row-class2 {
          height: 1200px;
      }
      .row-class3 {
          height: 2300px;
      }
      .result-div {
          display: flex;
          width: 100%;
          height: 70px;
          /* background-color: #a0d1f7; */
      }
      .result-img {
          flex: 0.04;
          margin-top: 25px;
          width: 100%;
          background: url("../../public/images/Bitmap.png") no-repeat;

      }
      .result-text {
          flex: 0.3;
          margin-top: 25px;
          font-size: 15px;
          width: 100%;
          text-align: start;
          color: #0077CF;
      }
      .result-space {
          flex: 0.1;
          width: 100%;
      }
      .result-steps1 {
          flex: 1;
          width: 100%;
          margin-top: 5px;
          background: url("../../public/images/R1.png") no-repeat;
      }
      .result-steps2 {
          flex: 1;
          width: 100%;
          margin-top: 5px;
          background: url("../../public/images/R2.png") no-repeat;
      }
      .result-steps3 {
          flex: 1;
          width: 100%;
          margin-top: 5px;
          background: url("../../public/images/R3.png") no-repeat;
      }
      .result-steps4 {
          flex: 1;
          width: 100%;
          margin-top: 5px;
          background: url("../../public/images/R4.png") no-repeat;
      }
      .result-steps5 {
          flex: 1;
          width: 100%;
          margin-top: 5px;
          background: url("../../public/images/R5.png") no-repeat;
      }
      .result-steps1,
      .result-steps2,
      .result-steps3,
      .result-steps4,
      .result-steps5 {
          min-width: 0;
          background-position: left center;
          background-size: 100% auto;
      }
      .calcuate-div {
          width: 100%;
          height: 210px;
      }
      .calcuate-title {
          display: flex;
          width: 100%;
          height: 50px;
          border-bottom: 1px solid #CCCCCC;
      }
      .sonrisk-div {
          flex: 1;
          width: 100%;
          text-align: start;
          font-size: 15px;
          align-self: center;
          font-weight: 600;
      }
      .sonrisk-space {
          flex: 4;
          width: 100%;
      }
      .sonrisk-sum {
          flex: 1;
          width: 100%;
          text-align: end;
          margin-top: 20px;
          font-size: 12px;
          font-weight: 600;
      }
      .sum-text {
          margin-left: 10px
      }
      .calcuate-result {
          width: 100%;
      }
      .calcuate-div .calcuate-result:last-child {
          width: 100%;
          border-bottom: 1px solid #CCCCCC;
      }
      .result-area {
          display: flex;
          width: 100%;
          height: 50px;
      }
      .result-compass {
          flex: 1.5;
          width: 100%;
          height: 20px;
          align-self: center;
          text-align: start;
      }
      .process-div {
          flex: 1;
          height: 15px;
          width: 100%;
      }
      .process-area {
          flex: 1;
          height: 15px;
          width: 100%;
          margin-top: 2px;
          background-color: #E8E7E9;
      }
      .process-step1 {
          flex: 1;
          height: 15px;
          position: relative;
          width: 20%;
          /* margin-left最大为220px，每一格为44px，改变这个值可以实现块条移动效果 */
          /* margin-left: 0px;  */
          background-color: #A1D0E3;
      }
      .process-step2 {
          background-color: #E8E7E9;
      }
      .process-circle-big2 {
          background-color: #E8E7E9;
      }
      .process-circle-small2 {
          background-color: #E8E7E9;
      }
      .process-circle-big {
          width: 20px;
          height: 20px;
          position: absolute;
          bottom: -3px;
          /* margin-left最大为35px，改变这个值可以实现圆圈移动效果 */
          /* margin-left: 0px; */
          background-color: #0077CF;
          border-radius: 50%;
      }
      .process-circle-small {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          margin-left: 4.6px;
          margin-top: 5px;
          background-color: #ffffff;
          position: initial;
          top: 50px;
          left: 50px;
      }
      .calcuate-space1 {
          flex: 1;
          width: 100%;
          text-align: start;
          align-self: center;
          margin-left: 5px;
          font-weight: 500;
      }
      .calcuate-space2 {
          flex: 0.15;
          width: 100%;
          text-align: start;
          align-self: center;
          margin-left: 5px;
          font-weight: 500;
      }
      .result-title {
          flex: 0.5;
          width: 100%;
          align-self: center;
          text-align: start;
      }
      .funtion-div {
          display: flex;
          width: 100%;
          height: 40px;
          /* background-color: rgb(182, 248, 226); */
      }
      .funtion-export {
          flex: 0;
          width: 100%;
          align-self: flex-end;
      }
      .funtion-import {
          flex: 1.2;
          width: 100%;
          align-self: flex-end;
      }
      .funtion-space {
          flex: 5;
          width: 100%;
      }
      .el-button.is-round {
          height: 35px;
      }

      .el-progress >>> .el-progress-bar__outer {
          border-radius: 0;
      }

      .el-progress >>> .el-progress-bar__inner {
          border-radius: 0;
      }
      .space-bottom {
          width: 50%;
          background-color: aquamarine;
      }
      .bottom-right-button {
          margin-left: 1150px;
      }
      .el-table >>> th.el-table__cell.is-leaf {
          background-color: rgb(247 247 247 / 10%);
      }
      .el-table--fit {
          border-bottom: 1px solid;
      }
      .portfolioRiskTable >>> table tr:first-child(1) {
          border-top: 1px solid !important;
      }
      .el-table >>> th.el-table__cell.is-leaf {
          border-bottom: 1px solid;
          border-top: 0;
      }
      .el-checkbox__inner::after {
          /* border: 0 !important; */
      }
      /* .el-table__header {
          border-bottom: 1px solid;
      }
      .el-table__body, .el-table__footer, .el-table__header */

/* .fade-leave-from,
.fade-enter-to {
  opacity: 1;
} */
/* .fade-leave-to,
.fade-enter-from {
  opacity: 0;
} */

/* .fade-leave-active, */
.fade-enter-active {
  /* transition: all 1s; */
  transition: all 0.5s linear;
    transform: translate3d(0, 0, 0);
}
/* .fade-leave, */
.fade-enter {
  transform: translate3d(100%, 0, 0);
}

.slideIn {
        animation: slideIn1 .3s ease forwards;
       /* // animation-fill-mode: forwards; */
      }
.slideOut {
        animation: slideOut .3s ease forwards;
        /* // animation-fill-mode: forwards; */
      }

      @keyframes slideIn1 {
0% {
        transform: translateX(0%);
}
      100% {
       transform: translateX(-50%);
 }
}
@keyframes slideOut {
    0% {
    transform: translateX(-50%);
    }
    100% {
    transform: translateX(0%);
    }
}

.ea-nav {
    position: relative;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
}

.ea-nav-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
    justify-content: center;
    align-items: center;
    width: 120px;
    overflow: hidden;
}

.ea-nav-done {
    position: relative;
}

.ea-nav-name {
    color: #5e5e5e;
    font-weight: 300;
    font-size: 16px;
    text-align: center;
}

.ea-nav-active .ea-nav-name {
    color: #1e1e1e;
    font-weight: 700;
}

.ea-nav-progress {
    position: relative;
    width: 100%;
    height: 30px;

    &::after {
        position: absolute;
        top: 50%;
        left: 50%;
        content: "";
        width: 100%;
        height: 3px;
        box-sizing: border-box;
        background-color: #ababab;
        transform: translate(-50%, -50%);
    }

    div {
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 1;
        width: 21px;
        height: 21px;
        border-radius: 50%;
        background-color: #fff;
        transform: translate(-50%, -50%);
        box-sizing: border-box;

        &::before {
            position: absolute;
            top: 50%;
            left: 50%;
            content: "";
            width: 11px;
            height: 11px;
            border-radius: 50%;
            background-color: #ababab;
            transform: translate(-50%, -50%);
        }
    }
}

.ea-nav-item:first-child .ea-nav-progress {
    &::after {
        left: 100%;
    }
}

.ea-nav-item:last-child .ea-nav-progress {
    &::after {
        left: 0%;
    }
}

.risk-result-main {
    overflow-x: auto;
}

.risk-result-main > .result-div,
.risk-result-main > .calcuate-div,
.risk-result-main > .funtion-div {
    min-width: 650px;
}

.ea-nav-item.ea-nav-done .ea-nav-progress {
    &::after {
        background-color: #0077cf;
    }

    div {
        border: 2px solid #0077cf;

        &::before {
            background-color: #0077cf;
        }
    }
}
</style>
